import React, { useState, useRef } from "react";
import Slider from "react-slick";
import useStyles, { FormInputSelect } from "./styles";
import Navbar2 from "../../components/Navbar2/Navbar2";
import Section from "../../components/Section/Section";
import Footer from "../../components/Footer/Footer";
import FormInputNoLabel from "../../components/FormInputNoLabel/FormInputNoLabel";
import Paragraph from "../../components/Typography/Paragraph";
import Card from "../../components/Card/Card";
import Loader from "react-js-loader";

import giftbox from "../../assets/images/giftbox.png";
import wallet from "../../assets/images/wallet.png";
import slot from "../../assets/images/slot.png";
import result from "../../assets/images/result.png";
import event from "../../assets/images/event.png";
import subscribe from "../../assets/images/subscribe.png";

import {
  Container,
  Grid,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Collapse,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  RadioGroup,
  Radio,
  FormControlLabel,
  TablePagination,
  Stack,
  Checkbox,
} from "@mui/material";
import Button from "../../components/Button/Button";
import {
  CheckCircleOutline,
  DoDisturbAlt,
  MoreVert,
  AddCircle,
  RemoveCircle,
  Edit,
  ArrowCircleDown,
  ArrowCircleUp,
  SubdirectoryArrowRight,
  Delete,
  KeyboardReturn,
  Search,
  Save,
  GridView,
  List,
  Close,
  Print,
  InsertDriveFile,
  InsertPhoto,
  CopyAll,
} from "@mui/icons-material";
import {
  get_orders_detail,
  orders_edit_item,
  orders_add_item,
  orders_remove_item,
  get_inventory_by_customer,
  approve_order,
  reject_order,
  get_customer_return,
  approve_consignment,
  approve_deposit,
  edit_order,
  get_merchandiser,
  update_merchandiser,
  get_sales_rep,
  manual_create_sales_order,
  process_order_admin,
  on_hold_listing,
  get_upload_file,
  calculate_discount,
  get_color_name,
  payment_link,
  print_sales_order,
  close_order,
  update_sales_order_shipping,
  get_address,
  get_shipping_carrier_by_id,
  get_shipping_method,
  get_shipping_method_admin,
  get_customer_detail,
  manual_post_order,
  manual_close_order,
  manual_update_attachment,
  manual_change_shipping,
  manual_customer_return,
  get_inventory_by_customer_children,
  manual_customer_payment,
} from "../../API/API";
import Countdown from "react-countdown";
import moment from "moment/moment";
import ShirtIcon from "../../assets/images/shirt.svg";

import "./styles.css";
import FormInput from "../../components/FormInput/FormInput";
import { useNavigate, useLocation, useParams, json } from "react-router-dom";
import toast from "react-simple-toasts";
import useUser from "../../hooks/useUser";
import { useDropzone } from "react-dropzone";

export default function SaleDetail() {
  const classes = useStyles();
  const navigate = useNavigate();
  const params = useParams();
  const OrderProductRef = useRef(null);

  const { set_user, get_user } = useUser();

  const location = useLocation();

  const [sort, setSort] = React.useState(0);

  const handleChangeSort = (event) => {
    setSort(event.target.value);
  };

  const [displayFloat, setDisplayFloat] = useState(false);
  const [searchKey, setSearchKey] = React.useState("");
  const [allData, setAllData] = React.useState([]);

  const handleSearch = (event) => {
    setSearchKey(event.target.value);
    var _data = searchData(allData, event.target.value);
    setInventory(_data);
    setTotalList(_data.length);
  };

  const searchData = (data, searchKey) => {
    // console.log(data, 'data', searchKey);
    var _data = [];
    if (searchKey != "") {
      for (var i = 0; i < data.length; i++) {
        // console.log(data[i].itemname.toUpperCase(), 'itemname match', searchKey, data[i].hscode.toUpperCase().indexOf(searchKey.toUpperCase()) > -1);
        if (
          data[i].itemname.toUpperCase().indexOf(searchKey.toUpperCase()) >
            -1 ||
          data[i].displayname.toUpperCase().indexOf(searchKey.toUpperCase()) >
            -1
        ) {
          _data.push(data[i]);
        } else if (data[i].children && data[i].children.length) {
          for (var j = 0; j < data[i].children.length; j++) {
            if (
              data[i].children[j].hscode
                .toUpperCase()
                .indexOf(searchKey.toUpperCase()) > -1 ||
              data[i].children[j].itemname
                .toUpperCase()
                .indexOf(searchKey.toUpperCase()) > -1 ||
              data[i].children[j].displayname
                .toUpperCase()
                .indexOf(searchKey.toUpperCase()) > -1 ||
              data[i].children[j].size
                .toUpperCase()
                .indexOf(searchKey.toUpperCase()) > -1 ||
              data[i].children[j].colorname
                .toUpperCase()
                .indexOf(searchKey.toUpperCase()) > -1
            ) {
              _data.push(data[i]);
            }
          }
        }
      }
    } else {
      _data = [...data];
    }
    // console.log(_data, '_data')
    return _data;
  };

  const [page, setPage] = React.useState("order");

  const [selectedShipping2, setSelectedShipping2] = React.useState(null);

  const [selectedCustomer, setSelectedCustomer] = React.useState(null);
  const [colorData, setColorData] = React.useState(null);
  const [colorSort, setColorSort] = React.useState("false");
  const [loading, setLoading] = React.useState(false);
  const [loadingItem, setLoadingItem] = React.useState(false);
  const [orderData, setOrderData] = React.useState(null);
  const [showPaymentLink, setShowPaymentLink] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [openAdd, setOpenAdd] = React.useState(false);
  const [openDelete, setOpenDelete] = React.useState(false);
  const [selectedItem, setSelectedItem] = React.useState(null);
  const [openType, setOpenType] = React.useState(false);
  const [selectedType, setSelectedType] = React.useState(0);
  const [returnData, setReturnData] = React.useState([]);
  const [shippingFee, setShippingFee] = React.useState("0.00");
  const [handlingFee, setHandlingFee] = React.useState("0.00");
  const [deposit, setDeposit] = React.useState("0.00");
  const [remark, setRemark] = React.useState({
    sales_remark: "",
    customer_remark: "",
    memo: "",
    bypasscl: false,
  });
  const [merchandiser, setMerchandiser] = React.useState(null);
  const [selectedMerchandiser, setSelectedMerchandiser] = React.useState("");
  const [rep, setRep] = React.useState(null);
  const [selectedRep, setSelectedRep] = React.useState("");
  const [pageNum, setPageNum] = React.useState(0);
  const [viewType, setViewType] = React.useState("grid");
  const [itemGridData, setItemGridData] = React.useState([]);
  const [totalList, setTotalList] = React.useState(1);
  const [productList, setProductList] = React.useState([]);
  const [openJson, setOpenJson] = React.useState(false);
  const [jsonData, setJsonData] = React.useState(null);
  const [customerPO, setCustomerPO] = React.useState("");
  const [attachment, setAttachment] = React.useState("");
  const [discountData, setDiscountData] = React.useState({
    discountpercent: (0).toFixed(2),
    discountvalue: (0).toFixed(2),
  });
  const [orderFee, setOrderFee] = React.useState({
    final_amount: (0).toFixed(2),
    handling_fee: (0).toFixed(2),
    shipping_fee: (0).toFixed(2),
    discountamount: (0).toFixed(4),
    total_amount: (0).toFixed(2),
    tax_fee: (0).toFixed(2),
  });
  const [customerContactID, setCustomerContactID] = React.useState("");
  const [customerAddressID, setCustomerAddressID] = React.useState("");
  const [orderDataStatus, setOrderDataStatus] = React.useState("");
  const [orderDataProcessed, setOrderDataProcessed] = React.useState("");
  const [customerID, setCustomerID] = React.useState(0);

  //

  const [shippingCarrier, setShippingCarrier] = React.useState([]);

  const [_shippingCarrier, _setShippingCarrier] = React.useState([]);

  const [_selectedCustomerAddress, _setSelectedCustomerAddress] =
    React.useState("");
  const [_selectedShippingMethod, _setSelectedShippingMethod] =
    React.useState("");
  const [_selectedShippingCarrier, _setSelectedShippingCarrier] =
    React.useState("");
  const [_selectedBillingAddress, _setSelectedBillingAddress] =
    React.useState("");

  const [customerType, setCustomerType] = React.useState("");

  const getData = async () => {
    try {
      setLoading(true);

      const ordersDetailResponse = await get_orders_detail({
        sales_order_id: params.sales_order_id,
      });

      var _products = [...ordersDetailResponse.data.item];
      for (var i = 0; i < ordersDetailResponse.data.item.length; i++) {
        _products[i]["description"] = decodeURIComponent(
          _products[i]["description"]
        );
      }
      ordersDetailResponse.data.item = _products;
      setOrderData(ordersDetailResponse.data);
      setCustomerContactID(ordersDetailResponse.data.customer_contact_id);
      setCustomerAddressID(ordersDetailResponse.data.customer_address_id);
      setOrderDataStatus(ordersDetailResponse.data.status_id);
      setOrderDataProcessed(ordersDetailResponse.data.processed);
      setCustomerID(ordersDetailResponse.data.customer_id);
      _setSelectedCustomerAddress(
        ordersDetailResponse.data.customer_address_id
      );
      _setSelectedShippingMethod(ordersDetailResponse.data.shipping_method_id);
      _setSelectedShippingCarrier(
        ordersDetailResponse.data.shipping_carrier_id
      );
      _setSelectedBillingAddress(ordersDetailResponse.data.billing_address_id);

      if (
        ordersDetailResponse.data.paymenttype === "Cash" &&
        ordersDetailResponse.data.outstanding_amount > 0
      ) {
        setShowPaymentLink(true);
      }

      setDiscountData({
        ...discountData,
        discountpercent: ordersDetailResponse.data.discountpercent,
        discountvalue: ordersDetailResponse.data.discountamount,
      });
      setOrderFee({
        ...orderFee,
        total_amount: ordersDetailResponse.data.total_amount,
        shipping_fee: ordersDetailResponse.data.shipping_fee,
        handling_fee: ordersDetailResponse.data.handling_fee,
        discountamount: ordersDetailResponse.discountamount,
        final_amount: ordersDetailResponse.data.final_amount,
        tax_fee:
          ordersDetailResponse.data.subsidiary === "2"
            ? ordersDetailResponse.data.sst
            : ordersDetailResponse.data.gst,
      });
      getInventory(ordersDetailResponse.data.customer_id);
      setSelectedCustomer({
        customer_id: ordersDetailResponse.data.customer_id,
      });
      setShippingFee(ordersDetailResponse.data.shipping_fee);
      setHandlingFee(ordersDetailResponse.data.handling_fee);
      setDeposit(ordersDetailResponse.data.deposit_amount);
      setRemark({
        ...remark,
        sales_remark: ordersDetailResponse.data.sales_remark,
        customer_remark: ordersDetailResponse.data.customer_remark,
        memo: ordersDetailResponse.data.memo,
        bypasscl: ordersDetailResponse.data.bypasscl === 1 ? true : false,
      });
      setSelectedMerchandiser(ordersDetailResponse.data.merchandiser);
      setSelectedRep(ordersDetailResponse.data.salesrep);
      setCustomerPO(ordersDetailResponse.data.customorderpo);
      setAttachment(ordersDetailResponse.data.attachment);

      setRazerID(ordersDetailResponse.data.razerid);

      const shippingMethodResponse = await get_shipping_method_admin({
        customer_contact_id: ordersDetailResponse.data.customer_contact_id,
      });
      setShippingMethod(shippingMethodResponse.data);

      const customerDetailResponse = await get_customer_detail({
        customer_id: ordersDetailResponse.data.customer_id,
      });
      setCustomerAddressList(customerDetailResponse.data.address);
      setCustomerType(customerDetailResponse.data.paymenttype);

      if (
        ordersDetailResponse.data.status_id === "3" &&
        ordersDetailResponse.data.processed === "0" &&
        ordersDetailResponse.data.is_ready === "1"
      ) {
        const postparam = {
          sales_order_id: params.sales_order_id,
        };
        const manualPostOrderResponse = await manual_post_order(postparam);
        if (manualPostOrderResponse.status) {
          // Handle success if needed
        }
      }

      if (
        ordersDetailResponse.data.status_id === "6" &&
        ordersDetailResponse.data.cancelled_date === ""
      ) {
        const postparam = {
          sales_order_id: params.sales_order_id,
        };
        const manualCloseOrderResponse = await manual_close_order(postparam);
        if (manualCloseOrderResponse.status) {
          // Handle success if needed
        }
      }

      if (
        ordersDetailResponse.data.status_id === "4" &&
        ordersDetailResponse.data.upload_attachment > 0
      ) {
        const postparam = {
          sales_order_id: params.sales_order_id,
        };
        const manualUpdateAttachmentResponse = await manual_update_attachment(
          postparam
        );
        if (manualUpdateAttachmentResponse.status) {
          // Handle success if needed
        }
      }

      if (
        ordersDetailResponse.data.status_id === "4" &&
        ordersDetailResponse.data.change_shipping === "1"
      ) {
        const postparam = {
          sales_order_id: params.sales_order_id,
        };
        const manualChangeShippingResponse = await manual_change_shipping(
          postparam
        );
        if (manualChangeShippingResponse.status) {
          // Handle success if needed
        }
      }

      if (
        ordersDetailResponse.data.status === "Processing" &&
        ordersDetailResponse.data.is_posted === "0"
      ) {
        const postparam = {
          sales_order_id: params.sales_order_id,
        };
        const manualCustomerReturnResponse = await manual_customer_return(
          postparam
        );
        if (manualCustomerReturnResponse.status) {
          // Handle success if needed
        }
      }

      const customerReturnResponse = await get_customer_return({
        sales_order_id: params.sales_order_id,
      });
      setReturnData(customerReturnResponse.data);

      const resMer = await get_merchandiser({});
      setMerchandiser(resMer.data);

      const resRep = await get_sales_rep({});
      setRep(resRep.data);

      const getColor = await get_color_name({});
      setColorData(getColor.data);

      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  React.useEffect(() => {
    getData();
  }, []);

  const handleChangeDiscount = (e) => {
    if (e.target.name == "discountvalue") {
      var temp_value =
        (parseFloat(e.target.value) /
          parseFloat(orderFee.total_amount.replace(/,/g, ""))) *
        100;
      setDiscountData({
        ...discountData,
        discountpercent: temp_value.toFixed(2),
        [e.target.name]: e.target.value,
      });
      return;
    }
    if (e.target.name == "discountpercent") {
      var temp_value =
        (parseFloat(e.target.value) / 100) *
        parseFloat(orderFee.total_amount.replace(/,/g, ""));
      setDiscountData({
        ...discountData,
        discountvalue: temp_value.toFixed(2),
        [e.target.name]: e.target.value,
      });
      return;
    }
  };

  React.useEffect(() => {
    if (selectedCustomer != null) {
      getInventory(selectedCustomer.customer_id);
    }
  }, [colorSort]);

  const handleOpenJson = (e) => {
    setJsonData(e);
    setOpenJson(true);
  };

  const handleCloseJson = (e) => {
    setJsonData(null);
    setOpenJson(false);
  };

  const handleChangePage = (e, ispage) => {
    setPageNum(ispage);
    // getData();
  };

  const handleChangeRemark = (e) => {
    setRemark({
      ...remark,
      [e.target.name]: e.target.value,
    });
  };

  const calculateDiscount = () => {
    if (orderData != null) {
      calculate_discount({
        ...discountData,
        sales_order_id: params.sales_order_id,
        // sort: sort
      }).then((json) => {
        // console.log(json);
        setOrderFee({
          ...orderFee,
          total_amount: json.total_amount,
          shipping_fee: json.shipping_fee,
          handling_fee: json.handling_fee,
          discountamount: json.discountamount,
          final_amount: json.final_amount,
          tax_fee: orderData.subsidiary == "2" ? json.sst : json.gst,
        });
      });
    }
  };

  React.useEffect(() => {
    calculateDiscount();
  }, [discountData, attachment, customerPO]);

  const [shippingMethodID, setShippingMethodID] = React.useState("");

  const [customerAddrsssList, setCustomerAddressList] = React.useState([]);

  const handleOpen = (e) => {
    console.log(e);
    setOpen(true);
    setSelectedItem({
      internalid: e.item,
      quantity: parseInt(e.quantity),
      given_discount: e.given_discount,
      description: e.description,
      hscode: e.hscode,
      itemname: e.itemname,
      color: e.colorname != "" ? e.colorname + " " + e.color : "",
      price: e.price,
      type: e.type,
      sales_order_item_id: e.sales_order_item_id,
    });
  };
  const handleClose = (value) => {
    setOpen(false);
  };

  const handleChangeProduct = (e) => {
    setSelectedItem({
      ...selectedItem,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeProduct2 = (e) => {
    const newValue = e.target.value;
    const newQuantity = newValue < 1 ? 1 : newValue;

    setSelectedItem({
      ...selectedItem,
      [e.target.name]: newQuantity,
    });
  };

  const [inventory, setInventory] = React.useState(null);

  const getInventory = (e) => {
    setLoadingItem(true);
    var temp_product = [];
    get_inventory_by_customer({
      customer_id: e,
      color: colorSort,
      // sort: sort
    }).then((json) => {
      setLoadingItem(false);
      temp_product = [...json.data];
      // temp_product[0]['openTable'] = true
      for (var i = 1; i < temp_product.length; i++) {
        temp_product[i]["openTable"] = false;
        // if (temp_product[i].children.length != 0) {
        //     for (var j = 0; j < temp_product[i].children.length; j++){

        //     }
        // }
      }
      // if()
      setAllData(temp_product);
      var _data = searchData(temp_product, searchKey);
      setInventory(_data);
      setTotalList(_data.length);
    });
  };

  // const handleChangeTable = (e) => {
  //   var temp_data = [...inventory];
  //   temp_data[e]["openTable"] = !temp_data[e]["openTable"];
  //   setInventory(temp_data);
  // };

  const handleChangeTable = async (item) => {
    if (!open[item.item_id]) {
      var res = await get_inventory_by_customer_children({
        internalid: item.internalid,
        customer_id: customerID,
      });
      if (res.status) {
        var _product = [...allData];
        item.children = res.data.children;
        item.children_grid = res.data.children_grid;

        setAllData(_product);
        var _data = searchData(_product, searchKey);
        setInventory(_data);
      }
    }

    setOpen((prev) => {
      const newState = { ...prev };
      Object.keys(newState).forEach((key) => {
        if (key !== item.item_id) {
          newState[key] = false;
        }
      });
      newState[item.item_id] = !prev[item.item_id];
      return newState;
    });
  };

  const handleSubmitEdit = () => {
    var _selectedItem = { ...selectedItem };
    _selectedItem["description"] = encodeURIComponent(
      _selectedItem["description"]
    );
    var data = {
      ..._selectedItem,
      sales_order_id: params.sales_order_id,
    };
    if (
      window.confirm(
        "Edit item will update shipping fee, are you sure you want to proceed?"
      )
    ) {
      orders_edit_item(data).then((json) => {
        // setLoadingAdd(true);
        if (json.status) {
          // setLoadingAdd(false);
          toast("Order Item Detail Save");
          handleClose();
          getData();
        } else {
          // setLoadingAdd(false);
          // toast(res.message)
        }
      });
    }
  };

  const handleOpenDelete = (e) => {
    setOpenDelete(true);
    setSelectedItem({
      internalid: e.item,
      quantity: parseInt(e.quantity),
      description: e.description,
      hscode: e.hscode,
      itemname: e.itemname,
      price: e.price,
      type: e.type,
      sales_order_item_id: e.sales_order_item_id,
    });
  };
  const handleCloseDelete = (value) => {
    setOpenDelete(false);
  };

  const handleDeleteItem = () => {
    var data = {
      ...selectedItem,
      sales_order_id: params.sales_order_id,
    };
    if (
      window.confirm(
        "Delete item will update shipping fee, are you sure you want to proceed?"
      )
    ) {
      orders_remove_item(data).then((json) => {
        // setLoadingAdd(true);
        if (json.status) {
          // setLoadingAdd(false);
          toast("Order Item Deleted");
          handleCloseDelete();
          getData();
        } else {
          // setLoadingAdd(false);
          // toast(res.message)
        }
      });
    }
  };

  const handleOpenAdd = (e) => {
    setOpenAdd(true);
    setSelectedItem({
      internalid: e.internalid,
      quantity: 1,
      description: "",
      hscode: e.hscode,
      itemname: e.itemname,
      color: e.colorname != "" ? e.colorname + " " + e.color : "",
      size: e.size != "" ? e.size : "",
      price: e.hasOwnProperty("price") ? e.price : "",
      type: e.type,
      quantityavailable: e.quantityavailable,
    });
  };
  const handleCloseAdd = (value) => {
    setOpenAdd(false);
  };

  const handleAddProduct = () => {
    if (
      selectedItem.type == "Matrix Item" &&
      parseFloat(selectedItem.quantity) >
        parseFloat(selectedItem.quantityavailable)
    ) {
      toast("Not Enough Quantity");
      return;
    }
    if (
      selectedItem.type != "Matrix Item" &&
      selectedItem.type != "Dropship Item" &&
      selectedItem.price == 0
    ) {
      toast("Please insert price");
      return;
    }

    var pro_temp = [...productList];
    if (pro_temp.length === 0) {
      selectedItem["index"] = 0;
      pro_temp.push(selectedItem);
    } else {
      var existed = 0;
      var index = 0;
      for (var i = 0; i < pro_temp.length; i++) {
        if (
          (selectedItem.type == "Matrix Item" ||
            selectedItem.type == "Dropship Item") &&
          pro_temp[i].internalid === selectedItem.internalid
        ) {
          existed = 1;
          index = i;
          break;
        } else if (
          selectedItem.type != "Matrix Item" &&
          selectedItem != "Dropship Item"
        ) {
          existed = 0;
          index = i;
          break;
        }
      }

      if (existed == 1) {
        if (
          (selectedItem.type == "Matrix Item" ||
            selectedItem.type == "Dropship Item") &&
          parseFloat(pro_temp[index].quantity) +
            parseFloat(selectedItem.quantity) >
            parseFloat(selectedItem.quantityavailable)
        ) {
          toast("Not Enough Quantity");
          return;
        }
        // console.log(parseFloat(pro_temp[index].quantity), parseFloat(selectedItem.quantity))
        var new_quantity =
          parseFloat(pro_temp[index].quantity) +
          parseFloat(selectedItem.quantity);

        pro_temp[index]["quantity"] = new_quantity;
        // cartTemp[index]['price'] = getPriceByQuantity(
        //     cartTemp[index],
        //     new_quantity,
        // );
      } else {
        selectedItem["index"] = pro_temp.length;
        pro_temp.push(selectedItem);
      }
    }
    setProductList(pro_temp);
    toast("Product Added");
    handleCloseAdd();
  };

  const handleSubmitAdd = () => {
    if (productList.length == 0) {
      toast("Please add item");
      return;
    }

    var _productList = [...productList];
    for (var i = 0; i < _productList.length; i++) {
      _productList[i]["description"] = encodeURIComponent(
        _productList[i]["description"]
      );
    }
    var data = {
      product: JSON.stringify(_productList),
      sales_order_id: params.sales_order_id,
    };

    if (
      window.confirm(
        "Add item will update shipping fee, are you sure you want to proceed?"
      )
    ) {
      setLoading(true);
      orders_add_item(data).then((json) => {
        // setLoadingAdd(true);
        if (json.status) {
          setLoading(false);
          // setLoadingAdd(false);
          toast("Order Item Added");
          getData();
          // setPage("order");
          setProductList([]);
          setOpen(false);
          setPage("order");
        } else {
          setLoading(false);
          toast(json.message);
        }
      });
    }
  };

  const handleApprove = () => {
    var data = {
      sales_order_id: params.sales_order_id,
    };
    if (window.confirm("Are you sure you want to approve this order?")) {
      setLoading(true);
      approve_order(data).then((json) => {
        setLoading(false);
        if (json.status) {
          // setLoadingAdd(false);
          toast("Order Approved");
          getData();
        } else {
          setLoading(false);
          toast(json.message);
        }
      });
    }
  };

  const handleChangeMerchandiser = async (e) => {
    const newMerchandiser = e.target.value;
    setSelectedMerchandiser(newMerchandiser);
    
    // Update merchandiser via API
    if (newMerchandiser && newMerchandiser !== "") {
      try {
        const updateData = {
          sales_order_id: params.sales_order_id,
          merchandiser: newMerchandiser,
        };
        console.log("Updating merchandiser on change:", updateData);
        const result = await update_merchandiser(updateData);
        if (result && result.status) {
          toast(result.message || "Merchandiser updated");
          console.log("Merchandiser updated successfully:", result);
        } else {
          toast(result?.message || "Error updating merchandiser");
        }
      } catch (error) {
        console.error("Error updating merchandiser:", error);
        toast("Error updating merchandiser");
      }
    }
  };

  const handleProcessOrder = async () => {
    var data = {
      sales_order_id: params.sales_order_id,
    };
    if (window.confirm("Are you sure you want to proceed this order?")) {
      setLoading(true);
      process_order_admin(data).then((json) => {
        // setLoadingAdd(true);
        if (json.status) {
          // setLoadingAdd(false);
          setLoading(false);
          toast("Order Proceeded");
          // getData()
          // navigate("../dashboard");
          window.location.reload();
        } else {
          setLoading(false);
          toast(json.message);
        }
      });
    }
  };

  const [paymentLink, setPaymentLink] = React.useState(null);
  const handleCreatePaymentLink = () => {
    var data = {
      sales_order_id: params.sales_order_id,
    };
    // if (window.confirm('Are you sure you want to proceed this order?')) {
    payment_link(data).then((json) => {
      // setLoadingAdd(true);
      if (json.status) {
        // setLoadingAdd(false);
        if (json.data != "") {
          // navigator.clipboard.writeText(json.data)
          setPaymentLink(json.data);
          toast("Payment link generated successful");
        } else {
          toast("No payment link was generated");
        }
        // toast('Order Proceeded')
        // getData()
      } else {
        // setLoadingAdd(false);
        // toast(res.message)
      }
    });
    // }
  };

  const handleCreateSalesOrder = () => {
    const user = get_user();
    // Try multiple possible field names for user name
    const proceedBy = user 
      ? (user.name || user.admin_name || user.username || user.email || "")
      : "";
    
    var data = {
      sales_order_id: params.sales_order_id,
      proceed_by: proceedBy,
    };
    if (window.confirm("Are you sure you want to create sale order?")) {
      manual_create_sales_order(data).then((json) => {
        // setLoadingAdd(true);
        if (json.status) {
          // setLoadingAdd(false);
          toast("Sale Order Created");
          getData();
        } else {
          // setLoadingAdd(false);
          // toast(res.message)
        }
      });
    }
  };

  const handleApproveDeposit = () => {
    var data = {
      sales_order_id: params.sales_order_id,
    };
    if (
      window.confirm("Are you sure you want to approve this order deposit?")
    ) {
      setLoading(true);
      approve_deposit(data).then((json) => {
        if (json.status) {
          setLoading(false);
          toast("Order Deposit Approved");
          getData();
        } else {
          setLoading(false);
          toast(json.message);
        }
      });
    }
  };

  const handlePrintSaleOrder = () => {
    var data = {
      sales_order_id: params.sales_order_id,
    };
    // if (window.confirm('Are you sure you want to approve this order deposit?')) {
    setLoading(true);
    print_sales_order(data).then((json) => {
      if (json.status) {
        setLoading(false);
        const url = json.data;
        window.open(url, "_blank");
        // toast('Order Deposit Approved')
        // getData()
      } else {
        setLoading(false);
        toast(json.message);
      }
    });
    // }
  };

  const handleReject = () => {
    var data = {
      sales_order_id: params.sales_order_id,
    };
    if (window.confirm("Are you sure you want to reject this order?")) {
      setLoading(true);
      reject_order(data).then((json) => {
        setLoading(false);
        if (json.status) {
          // setLoadingAdd(false);
          toast("Order Rejected");
          getData();
        } else {
          setLoading(false);
          toast(json.message);
        }
      });
    }
  };

  const handleApproveConsignment = () => {
    var data = {
      sales_order_id: params.sales_order_id,
    };
    if (
      window.confirm("Are you sure you want to remove this order shipping fee?")
    ) {
      approve_consignment(data).then((json) => {
        // setLoadingAdd(true);
        if (json.status) {
          // setLoadingAdd(false);
          toast("Order Shipping Fee Remove");
          getData();
        } else {
          // setLoadingAdd(false);
          // toast(res.message)
        }
      });
    }
  };

  const handleOpenType = () => {
    // setOpenType(true)
    navigate("/salereturn/" + orderData.sales_order_id + "/" + 0);
  };

  const handleCloseType = () => {
    setOpenType(false);
    navigate("/salereturn/" + orderData.sales_order_id + "/" + selectedType);
  };

  const handleChangeDiscountText = (index, e) => {
    var pro_temp = [...orderData.item];
    var new_discount = parseFloat(e.target.value);
    if (isNaN(new_discount)) {
      new_discount = 0;
    }
    pro_temp[index]["given_discount"] = new_discount;
    setProductList(pro_temp);
    // calculateCart();
  };

  const handleSaveDetail = () => {
    var data = {
      ...remark,
      ...discountData,
      bypasscl: remark.bypasscl ? 1 : 0,
      sales_order_id: params.sales_order_id,
      shipping_fee: shippingFee,
      handling_fee: handlingFee,
      deposit_amount: deposit,
      merchandiser: selectedMerchandiser,
      salesrep: selectedRep,
      customorderpo: customerPO,
      attachment: attachment,
      customer_address_id: _selectedCustomerAddress,
      shipping_method_id: _selectedShippingMethod,
      shipping_carrier_id: _selectedShippingCarrier,
    };

    // console.log(data)
    if (window.confirm("Are you sure you want to edit this order details?")) {
      setLoading(true);
      edit_order(data).then((json) => {
        if (json) {
          // setLoadingAdd(false);
          toast("Order Detail Save");
          getData();
          window.location.reload();
        } else {
          setLoading(false);
          toast(json.message);
        }
      });
    }
  };
  const [openAddDesc, setOpenAddDesc] = React.useState(false);
  const [selectedGrid, setSelectedGrid] = React.useState(null);
  const [openEditDesc, setOpenEditDesc] = React.useState(false);
  const [openEditDis, setOpenEditDis] = React.useState(false);
  const [selectedIndexProduct, setSelectedIndexProduct] = React.useState(null);

  const handleRemoveItem = (i) => {
    var temp_data = [...productList];
    // console.log(temp_data)
    temp_data.splice(i, 1);
    // console.log(temp_data)
    setProductList(temp_data);
  };
  const handleOpenAddIndexProduct = (e) => {
    console.log(e);
    setOpenEditDesc(true);
    setSelectedIndexProduct({
      ...e,
    });
  };
  const handleCloseIndexProduct = (e) => {
    var pro_temp = [...productList];
    pro_temp[selectedIndexProduct.index]["description"] =
      selectedIndexProduct.description;
    setProductList(pro_temp);
    setSelectedIndexProduct(null);
    setOpenEditDesc(false);
  };

  const handleOpenAddIndexProductDiscount = (e) => {
    console.log(e);
    setOpenEditDis(true);
    setSelectedIndexProduct({
      ...e,
    });
  };
  const handleCloseIndexProductDiscount = (e) => {
    var pro_temp = [...productList];
    pro_temp[selectedIndexProduct.index]["given_discount"] =
      selectedIndexProduct.given_discount;
    setProductList(pro_temp);
    setSelectedIndexProduct(null);
    setOpenEditDis(false);
  };

  const handleChangeIndexProduct = (e) => {
    setSelectedIndexProduct({
      ...selectedIndexProduct,
      [e.target.name]: e.target.value,
    });
  };
  // console.log(inventory);

  const handleChangeQty = (index, qty) => {
    var pro_temp = [...productList];
    var new_quantity = parseFloat(pro_temp[index].quantity) + parseFloat(qty);

    if (
      pro_temp[index].itemtype == "Matrix Item" &&
      parseFloat(new_quantity) > parseFloat(pro_temp[index].quantityavailable)
    ) {
      toast("Not Enough Quantity");
      return;
    }

    pro_temp[index]["quantity"] = new_quantity;

    for (var i = 0; i < pro_temp.length; i++) {
      if (pro_temp[i].quantity < 1) {
        pro_temp.splice(i, 1);
      }
    }

    setProductList(pro_temp);
  };

  const handleOpenAddDesc = (e) => {
    setOpenAddDesc(true);
    setSelectedGrid({
      ...e,
      description: "",
    });
  };

  const handleChangeDesc = (e) => {
    setSelectedGrid({
      ...selectedGrid,
      [e.target.name]: e.target.value,
    });
  };
  const handleCloseAddDesc = (e) => {
    setSelectedGrid(null);
    setOpenAddDesc(false);
  };

  const handleAddDEsc = () => {
    // console.log(selectedGrid)
    if (parseFloat(selectedGrid.quantityavailable) < 1) {
      toast("Not Enough Quantity");
      return;
    }
    var temp_list = [...productList];
    var data = {
      ...selectedGrid,
      quantity: 1,
    };

    let existed = false;
    let index = 0;
    for (let i = 0; i < temp_list.length; i++) {
      if (temp_list[i].internalid === data.internalid) {
        existed = true;
        index = i;
        break;
      }
    }

    if (existed) {
      if (
        parseFloat(temp_list[index].quantity) + parseFloat(data.quantity) >
        parseFloat(selectedGrid.quantityavailable)
      ) {
        toast("Not Enough Quantity");
        return;
      }
      temp_list[index].quantity =
        parseFloat(temp_list[index].quantity) + parseFloat(data.quantity);
      // temp_list[index].description = parseFloat(data.quantity);
      if (temp_list[index].description.length == 0) {
        temp_list[index].description = data.description;
      }
    } else {
      data.index = temp_list.length;
      temp_list.push(data);
    }
    setProductList(temp_list);
    // toast('Product Added');
    handleCloseAddDesc();
  };

  // const handleChangeGrid = (e, item) => {
  //   if (e.target.value == "") {
  //     toast("Please Insert Quantity");
  //     return;
  //   }
  //   if (e.target.value == 0) {
  //     toast("Quantity Cannot be 0");
  //     return;
  //   }
  //   var temp_list = [...productList];

  //   var insertData = e.target.id;
  //   var datasplit = insertData.split("_");
  //   var internalid = datasplit[0];
  //   var hscode = datasplit[1];
  //   var itemname = datasplit[2];
  //   var price = datasplit[3];
  //   var type = datasplit[4];
  //   var color = datasplit[5];
  //   var quantityavailable = datasplit[6];
  //   var size = datasplit[7];
  //   if (parseFloat(e.target.value) > parseFloat(quantityavailable)) {
  //     toast("Not Enough Quantity");
  //     return;
  //   }
  //   // console.log(datasplit, index)
  //   var data = {
  //     hscode: hscode,
  //     itemname: itemname,
  //     price: price,
  //     type: type,
  //     color: color,
  //     quantity: e.target.value,
  //     internalid: internalid,
  //     description: "",
  //     quantityavailable: quantityavailable,
  //     size: size,
  //   };

  //   let existed = false;
  //   let index = 0;
  //   for (let i = 0; i < temp_list.length; i++) {
  //     if (temp_list[i].internalid === data.internalid) {
  //       existed = true;
  //       index = i;
  //       break;
  //     }
  //   }

  //   if (existed) {
  //     if (
  //       parseFloat(temp_list[index].quantity) + parseFloat(data.quantity) >
  //       parseFloat(quantityavailable)
  //     ) {
  //       toast("Not Enough Quantity");
  //       return;
  //     }
  //     temp_list[index].quantity =
  //       parseFloat(temp_list[index].quantity) + parseFloat(data.quantity);
  //     // temp_list[index].quantity = parseFloat(data.quantity);
  //   } else {
  //     data.index = temp_list.length;
  //     temp_list.push(data);
  //   }
  //   setProductList(temp_list);
  //   // toast('Product Added');
  // };

  const handleChangeGrid = (e, item) => {
    if (e.target.value == "") {
      toast("Please Insert Quantity");
      return;
    }
    if (e.target.value == 0) {
      toast("Quantity Cannot be 0");
      return;
    }
    var temp_list = [...productList];

    var insertData = e.target.id;
    var datasplit = insertData.split("_");
    var internalid = datasplit[0];
    var hscode = datasplit[1];
    var itemname = datasplit[2];
    var price = datasplit[3];
    var type = datasplit[4];
    var color = datasplit[5];
    var quantityavailable = datasplit[6];
    var size = datasplit[7];
    var quantity = e.target.value !== "" ? parseInt(e.target.value) : 0;

    if (quantity > 0) {
      if (item.itemtype == "Matrix Item" && quantity > quantityavailable) {
        toast("Not enough quantity available");
        return;
      }
      var data = {
        hscode: hscode,
        itemname: itemname,
        price: price,
        type: type,
        color: color,
        quantity: e.target.value,
        internalid: internalid,
        description: "",
        quantityavailable: quantityavailable,
        size: size,
      };
      console.log("data", data);

      var existed = 0;

      for (let i = 0; i < temp_list.length; i++) {
        if (internalid == temp_list[i].internalid) {
          existed = 1;
          temp_list[i] = data;
        }
      }

      if (existed == 0 && data.quantity >= 1) {
        data["index"] = temp_list.length;
        temp_list.push(data);
      }
    } else {
      for (var i = 0; i < temp_list.length; i++) {
        if (internalid == temp_list[i].internalid) {
          temp_list.splice(i, 1);
        }
      }
    }

    // console.log(datasplit, index)

    setProductList(temp_list);
    // toast('Product Added');
  };

  // const handleChangeGrid = (e, index, item) => {
  //   if (e.target.value == "") {
  //     toast("Please Insert Quantity");
  //     return;
  //   }
  //   if (e.target.value == 0) {
  //     toast("Quantity Cannot be 0");
  //     return;
  //   }

  //   let list = [...productList];

  //   var data = e.target.id;
  //   var datasplit = data.split("_");
  //   var internalid = datasplit[0];
  //   var hscode = datasplit[1];
  //   var itemname = datasplit[2];
  //   var price = datasplit[3];
  //   var type = datasplit[4];
  //   var color = datasplit[5];
  //   var quantityavailable = datasplit[6];
  //   var size = datasplit[7];
  //   var quantity = e.target.value !== "" ? parseInt(e.target.value) : 0;

  //   if (quantity > 0) {
  //     if (item.type != "Dropship Item" && quantity > quantityavailable) {
  //       toast("Not enough quantity available");
  //       return;
  //     }

  //     var data = {
  //       hscode: hscode,
  //       itemname: itemname,
  //       price: price,
  //       type: type,
  //       color: color,
  //       quantity: e.target.value,
  //       internalid: internalid,
  //       description: "",
  //       quantityavailable: quantityavailable,
  //       size: size,

  //     };

  //     console.log("data", data);
  //     var existed = 0;
  //     // alert(open_product_list_counter.current)

  //     for (var i = 0; i < list.length; i++) {
  //       if (internalid == list[i].internalid) {
  //         existed = 1;
  //         list[i] = data;
  //       }
  //     }

  //     if (existed == 0 && data.quantity >= 1) {
  //       data["index"] = list.length;
  //       list.push(data);
  //     }
  //   } else {
  //     for (var i = 0; i < list.length; i++) {
  //       if (internalid == list[i].internalid) {
  //         list.splice(i, 1);
  //       }
  //     }
  //   }

  //   setProductList(list);
  // };

  const handleCaptureSingle = async (e, index) => {
    var formData = new FormData();
    // var token = window.localStorage.getItem("token");
    // formData.append("token", token);
    formData.append("image", e.target.files[0]);
    // setisLoading(true);
    var res = await get_upload_file(formData);
    // console.log(res)
    if (res.data.status) {
      if (e.target.name == "attachment") {
        setAttachment(res.data.data);
        return;
      }
      if (e.target.name == "customerpo") {
        setCustomerPO(res.data.data);
        return;
      }
    } else {
      toast(res.data.message);
    }
  };

  //DropZone

  const dropzone = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    borderWidth: "2px",
    borderRadius: "2px",
    borderColor: "#eeeeee",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    outline: "none",
    marginBottom: ".6rem",
  };

  const [files, setFiles] = React.useState([]);
  const [files2, setFiles2] = React.useState([]);

  const attachmentDropzone = useDropzone({
    maxFiles: 1,
    onDrop: async (acceptedFiles) => {
      console.log(acceptedFiles);
      if (acceptedFiles.length === 1) {
        const file = acceptedFiles[0];
        var index = 0;
        var formData = new FormData();
        formData.append("image", file);

        var res = await get_upload_file(formData);
        if (res.data.status) {
          setAttachment(res.data.data);
        } else {
        }
      } else {
        toast("Please Upload One File Only");
      }
      setFiles(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    },
  });

  const customerpoDropzone = useDropzone({
    maxFiles: 1,
    onDrop: async (acceptedFiles) => {
      console.log(acceptedFiles);
      if (acceptedFiles.length === 1) {
        const file = acceptedFiles[0];
        var index = 0;
        var formData = new FormData();
        formData.append("image", file);

        var res = await get_upload_file(formData);
        if (res.data.status) {
          setCustomerPO(res.data.data);
        } else {
        }
      } else {
        toast("Please Upload One File Only");
      }
      setFiles2(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    },
  });

  const thumbs = files.map((file, index) => (
    <div
      style={{
        background: "#eaeaea",
        borderRadius: "4px",
        padding: "1rem",
        marginBottom: "1rem",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <div key={file.name} style={{ display: "flex", alignItems: "center" }}>
        {file.type == "application/pdf" && (
          <InsertDriveFile sx={{ marginRight: "12px", color: "#F90000" }} />
        )}
        {file.type == "image/png" && (
          <InsertPhoto sx={{ marginRight: "12px", color: "#00b5a2" }} />
        )}

        {file.type == "image/jpeg" && (
          <InsertPhoto sx={{ marginRight: "12px", color: "#00b5a2" }} />
        )}

        <p style={{ margin: 0 }}>{file.name}</p>
      </div>
      <Close
        sx={{ color: "#F90000", zIndex: 1 }}
        onClick={() => handleDelete(index)}
      />
    </div>
  ));

  const thumbs2 = files2.map((file, index) => (
    <div
      style={{
        background: "#eaeaea",
        borderRadius: "4px",
        padding: "1rem",
        marginBottom: "1rem",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <div key={file.name} style={{ display: "flex", alignItems: "center" }}>
        {file.type == "application/pdf" && (
          <InsertDriveFile sx={{ marginRight: "12px", color: "#F90000" }} />
        )}
        {file.type == "image/png" && (
          <InsertPhoto sx={{ marginRight: "12px", color: "#00b5a2" }} />
        )}

        {file.type == "image/jpeg" && (
          <InsertPhoto sx={{ marginRight: "12px", color: "#00b5a2" }} />
        )}

        <p style={{ margin: 0 }}>{file.name}</p>
      </div>
      <Close
        sx={{ color: "#F90000", zIndex: 1 }}
        onClick={() => handleDelete2(index)}
      />
    </div>
  ));

  const handleDelete = async (fileIndex) => {
    const updatedFiles = [...files];
    updatedFiles.splice(fileIndex, 1);
    setFiles(updatedFiles);
    setAttachment("");
  };

  const handleDelete2 = async (fileIndex) => {
    const updatedFiles = [...files2];
    updatedFiles.splice(fileIndex, 1);
    setFiles2(updatedFiles);
    setCustomerPO("");
  };

  const [token, setToken] = React.useState([]);

  React.useEffect(() => {
    let token = window.localStorage.getItem("token");
    setToken(token || "");
  }, []);

  const [loadingAdd, setLoadingAdd] = React.useState(false);

  const handleCancelSaleOrder = () => {
    setLoadingAdd(true);
    if (window.confirm("Are you sure you want to cancel order?")) {
      close_order({ sales_order_id: params.sales_order_id, token: token }).then(
        (json) => {
          if (typeof json.status !== "undefined") {
            setLoadingAdd(false);
            alert(json.message);
          } else {
            window.location.reload();
          }
        }
      );
    } else {
      setLoadingAdd(false);
    }
  };

  const [addressList, setAddressList] = React.useState([]);
  const [shippingMethod, setShippingMethod] = React.useState([]);

  React.useEffect(() => {
    if (shippingMethod.length && orderData) {
      for (var i = 0; i < shippingMethod.length; i++) {
        if (
          orderData.shipping_method_id == shippingMethod[i].shipping_method_id
        ) {
          console.log(shippingMethod[i]);
          _setShippingCarrier(shippingMethod[i].carrier);
        }
      }
    }
  }, [shippingMethod, orderData]);

  const [selectedCustomerAddress, setSelectedCustomerAddress] =
    React.useState("");

  const handleChooseCustomerAddress = (e) => {
    setSelectedCustomerAddress(e.target.value);
    console.log(e.target.value);
  };

  const [selectedShippingMethod, setSelectedShippingMethod] =
    React.useState("");
  const [selectedShippingCarrier, setSelectedShippingCarrier] =
    React.useState("");

  const handleChangeShippingMethod = (e) => {
    const selectedMethodId = e.target.value;
    setSelectedShippingMethod(selectedMethodId);

    const selectedMethod = shippingMethod.find(
      (item) => item.shipping_method_id === selectedMethodId
    );

    console.log(selectedMethod);
    if (selectedMethod) {
      const carriers = selectedMethod.carrier;
      setShippingCarrier(carriers);
      console.log(carriers);
    }
  };

  const handleChangeShippingCarrier = (e) => {
    setSelectedShippingCarrier(e.target.value);
  };

  // FOR USER EDIT SHIPPING ADDRESS AMD SO ON

  const _handleChooseCustomerAddress = (e) => {
    _setSelectedCustomerAddress(e.target.value);
    console.log(e.target.value);
  };

  const _handleChangeShippingMethod = (e) => {
    const selectedMethodId = e.target.value;
    _setSelectedShippingMethod(selectedMethodId);

    const selectedMethod = shippingMethod.find(
      (item) => item.shipping_method_id === selectedMethodId
    );
    if (selectedMethod) {
      const carriers = selectedMethod.carrier;
      _setShippingCarrier(carriers);
      console.log(carriers);

      _setSelectedShippingCarrier(carriers[0].shipping_carrier_id);
    } else {
      setShippingCarrier([]);
      _setSelectedShippingCarrier("");
    }
  };

  const _handleChangeShippingCarrier = (e) => {
    _setSelectedShippingCarrier(e.target.value);
  };

  React.useEffect(() => {}, [
    customerContactID,
    customerAddressID,
    orderDataStatus,
    orderDataProcessed,
    customerID,
    customerType,
  ]);

  const [openEditShippingMethod, setOpenEditShippingMethod] =
    React.useState(false);

  const handleOpenEditShippingMethod = (e) => {
    setOpenEditShippingMethod(true);
    // alert("OK");

    get_orders_detail({ sales_order_id: params.sales_order_id }).then(
      (json) => {
        setSelectedCustomerAddress(json.data.customer_address_id);
        // setSelectedShippingMethod(json.data.shipping_method_id);
      }
    );
  };

  const handleCloseShippingMethod = () => {
    setOpenEditShippingMethod(false);
  };

  const handleSubmitEditShippingMethod = () => {
    if (selectedShippingMethod == "") {
      toast("Please Choose a Shipping Method");
      return;
    }

    if (shippingCarrier.length != 0) {
      if (selectedShippingCarrier == "") {
        toast("Please Choose a Carrier");
        return;
      }
    }

    let postparam = {
      sales_order_id: params.sales_order_id,
      shipping_method_id: selectedShippingMethod,
      shipping_carrier_id: selectedShippingCarrier,
      customer_address_id: selectedCustomerAddress,
    };

    // console.log(postparam);
    update_sales_order_shipping(postparam).then((json) => {
      if (json.status) {
        toast("Submit Successfully");
        window.location.reload();
        // setOpenEditShippingMethod(false)
      }
    });
  };
  // console.log(orderDataStatus)

  const [openInput, setOpenInput] = React.useState(false);

  const handleOpenInput = () => {
    setOpenInput(true);
  };

  const [razerID, setRazerID] = React.useState("");
  const [tranDate, setTranDate] = React.useState("");

  const handleChangeRazerID = (e) => {
    setRazerID(e.target.value);
  };

  const handleChangeTranDate = (e) => {
    setTranDate(e.target.value);
  };

  const handleResync = () => {
    if (razerID == 0) {
      alert("Razer ID cannot be 0");
      return;
    }
    if (tranDate == "") {
      alert("Please Insert a Date");
      return;
    }
    manual_customer_payment({
      sales_order_id: params.sales_order_id,
      razerid: razerID,
      tranDate: tranDate,
    }).then((json) => {
      if (json.status) {
        alert("Resync Successfully");
      } else {
        alert(json.message);
      }
    });
  };

  // COPY ORDER FUNCTION

  const [copyData, setCopyData] = React.useState([]);

  const handleCopyOrder = () => {
    // window.localStorage.setItem("order", JSON.stringify(orderData));

    // setCopyData(orderData)

    navigator.clipboard
      .writeText(JSON.stringify(orderData))
      .then(() => alert("Your Order Copied!"))
      .catch((error) => console.error("Error copying data:", error));

    navigate("/createorder");
  };

  const handleDO = () => {
    window.open(orderData.do_link);
  };

  return (
    <React.Fragment>
      {loading ? (
        <div style={{ margin: "auto" }}>
          <Loader type="bubble-loop" bgColor="#1A5386" size={50} />
        </div>
      ) : (
        <React.Fragment>
          {page === "order" ? (
            <Navbar2
              children={
                <Section pd="2rem">
                  {orderData != null && (
                    <React.Fragment>
                      <div>
                        <div
                          onClick={() => navigate(-1)}
                          style={{
                            cursor: "pointer",
                          }}
                        >
                          <Paragraph
                            color="#000"
                            bold="400"
                            size="12px"
                            margin="0 0 1rem"
                          >
                            &lt; Back
                          </Paragraph>
                        </div>
                        <div className={classes.theFlexHeader}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Paragraph
                              color="#1A5386"
                              bold="600"
                              size="24px"
                              margin="0 10px 0 0"
                            >
                              Order Number:{" "}
                              {orderData.sales_order_id != "" &&
                              orderData.sales_order_id != null
                                ? orderData.sales_order_id
                                : "-"}
                            </Paragraph>
                            {orderData.json_body != "" && (
                              <div
                                style={{
                                  width: "10px",
                                  height: "10px",
                                  borderRadius: "50%",
                                  backgroundColor: "#707070 ",
                                }}
                                onClick={() =>
                                  handleOpenJson(orderData.json_body)
                                }
                              ></div>
                            )}
                          </div>

                          <div
                            className={classes.theFlexBtn}
                            style={{ marginBottom: "0" }}
                          >
                            {get_user().internalid == 117 ||
                              get_user().internalid == 820 ||
                              (get_user().internalid == 0 && (
                                <React.Fragment>
                                  <a
                                    style={{ backgroundColor: "#1a5386" }}
                                    className={classes.theCustomActionBtnFill}
                                    onClick={() => handleOpenInput()}
                                  >
                                    <Paragraph>Resync Payment</Paragraph>
                                  </a>
                                </React.Fragment>
                              ))}

                            {orderData.invoiceid != 0 &&
                              returnData.length != 0 && (
                                <React.Fragment>
                                  <a
                                    style={{ backgroundColor: "#C52626" }}
                                    className={classes.theCustomActionBtnFill}
                                    onClick={() =>
                                      navigate(
                                        "/salereturnlist/" +
                                          params.sales_order_id
                                      )
                                    }
                                  >
                                    <Search sx={{ color: "#fff" }} />
                                    <Paragraph margin="0 0 0 .4rem">
                                      View Good Return List
                                    </Paragraph>
                                  </a>
                                </React.Fragment>
                              )}
                            {orderData.status_id == 4 &&
                              orderData.picked == 0 && (
                                <React.Fragment>
                                  <a
                                    style={{ backgroundColor: "#1A5386" }}
                                    className={classes.theCustomActionBtnFill}
                                    onClick={(item) =>
                                      handleOpenEditShippingMethod(item)
                                    }
                                  >
                                    <Edit sx={{ color: "#fff" }} />
                                    <Paragraph margin="0 0 0 .4rem">
                                      Change Shipping Method
                                    </Paragraph>
                                  </a>
                                </React.Fragment>
                              )}
                            {orderData.status_id == 5 &&
                              orderData.invoiceid != 0 && (
                                <React.Fragment>
                                  <a
                                    style={{ backgroundColor: "#C52626" }}
                                    className={classes.theCustomActionBtnFill}
                                    onClick={() => handleOpenType()}
                                    // onClick={() => navigate("/salereturn/" + orderData.sales_order_id)}
                                  >
                                    {/* <KeyboardReturn sx={{ color: '#fff' }} /> */}
                                    <Paragraph
                                    // margin='0 0 0 .4rem'
                                    >
                                      Good Return
                                    </Paragraph>
                                  </a>
                                </React.Fragment>
                              )}
                            {orderData.paymenttype != "Cash" &&
                            orderData.status_id == 2 &&
                            orderData.processed == 0 ? (
                              <React.Fragment>
                                <a
                                  style={{ backgroundColor: "#1A8649" }}
                                  className={classes.theCustomActionBtnFill}
                                  onClick={() => handleCreateSalesOrder()}
                                >
                                  <CheckCircleOutline sx={{ color: "#fff" }} />
                                  <Paragraph margin="0 0 0 .4rem">
                                    Proceed
                                  </Paragraph>
                                </a>
                              </React.Fragment>
                            ) : (
                              <></>
                            )}

                            {orderData.paymenttype != "Cash" &&
                            orderData.status_id == 3 &&
                            orderData.processed == 0 ? (
                              <React.Fragment>
                                <a
                                  style={{ backgroundColor: "#1A8649" }}
                                  className={classes.theCustomActionBtnFill}
                                  onClick={() => handleCreateSalesOrder()}
                                >
                                  <CheckCircleOutline sx={{ color: "#fff" }} />
                                  <Paragraph margin="0 0 0 .4rem">
                                    Proceed
                                  </Paragraph>
                                </a>
                              </React.Fragment>
                            ) : (
                              <></>
                            )}

                            {orderData.paymenttype == "Cash" &&
                            orderData.status_id == 2 &&
                            orderData.processed == 0 &&
                            parseFloat(orderData.remainingamt) == 0 ? (
                              <React.Fragment>
                                <a
                                  style={{ backgroundColor: "#1A8649" }}
                                  className={classes.theCustomActionBtnFill}
                                  onClick={() => handleCreateSalesOrder()}
                                >
                                  <CheckCircleOutline sx={{ color: "#fff" }} />
                                  <Paragraph margin="0 0 0 .4rem">
                                    Proceed
                                  </Paragraph>
                                </a>
                              </React.Fragment>
                            ) : (
                              <></>
                            )}

                            {/* {orderData.status_id == "3" &&
                              orderData.processed === "0" && (
                                <React.Fragment>
                                  <a
                                    style={{ backgroundColor: "#1A8649" }}
                                    className={classes.theCustomActionBtnFill}
                                    onClick={() => handleProcessOrder()}
                                  >
                                    <CheckCircleOutline
                                      sx={{ color: "#fff" }}
                                    />
                                    <Paragraph margin="0 0 0 .4rem">
                                      Proceed
                                    </Paragraph>
                                  </a>
                                </React.Fragment>
                              )} */}

                            {loadingAdd ? (
                              <div style={{}}>
                                <Loader
                                  type="bubble-loop"
                                  bgColor="#1A5386"
                                  size={50}
                                />
                              </div>
                            ) : (
                              <React.Fragment>
                                {orderData.picked == 0 &&
                                  orderData.status_id < 6 && (
                                    <a
                                      style={{ backgroundColor: "#F90000" }}
                                      className={classes.theCustomActionBtnFill}
                                      onClick={() => handleCancelSaleOrder()}
                                    >
                                      <Close sx={{ color: "#fff" }} />
                                      <Paragraph margin="0 0 0 .4rem">
                                        Cancel Order
                                      </Paragraph>
                                    </a>
                                  )}

                                <a
                                  style={{ backgroundColor: "#1A5386" }}
                                  className={classes.theCustomActionBtnFill}
                                  onClick={() => handlePrintSaleOrder()}
                                >
                                  <Print sx={{ color: "#fff" }} />
                                  <Paragraph margin="0 0 0 .4rem">
                                    Print
                                  </Paragraph>
                                </a>
                              </React.Fragment>
                            )}

                            {orderData.status_id == 1 && (
                              <React.Fragment>
                                <a
                                  style={{ backgroundColor: "#1A8649" }}
                                  className={classes.theCustomActionBtnFill}
                                  onClick={() => handleApprove()}
                                >
                                  <CheckCircleOutline sx={{ color: "#fff" }} />
                                  <Paragraph margin="0 0 0 .4rem">
                                    Approve
                                  </Paragraph>
                                </a>
                                <a
                                  style={{ backgroundColor: "#C52626" }}
                                  className={classes.theCustomActionBtnFill_}
                                  onClick={() => handleReject()}
                                >
                                  <DoDisturbAlt sx={{ color: "#fff" }} />
                                  <Paragraph margin="0 0 0 .4rem">
                                    Reject
                                  </Paragraph>
                                </a>
                              </React.Fragment>
                            )}

                            <a
                              style={{ backgroundColor: "#1A5386" }}
                              className={classes.theCustomActionBtnFill}
                              onClick={() => handleCopyOrder()}
                            >
                              <CopyAll sx={{ color: "#fff" }} />
                              <Paragraph margin="0 0 0 .4rem">
                                Copy Order
                              </Paragraph>
                            </a>
                          </div>
                        </div>
                        <div
                          style={{
                            borderBottom: "2px solid #707070",
                            padding: ".2rem 0",
                          }}
                        />
                        <br />
                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={12} md={6}>
                            <Grid container spacing={3}>
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">
                                  Order Date & Time:
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {orderData.created_date != "" &&
                                  orderData.created_date != null
                                    ? orderData.created_date
                                    : "-"}
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">Order Date:</Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {orderData.orderdate != "" &&
                                  orderData.orderdate != null
                                    ? orderData.orderdate
                                    : "-"}
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">Deposit Date:</Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {orderData.depositdate != "" &&
                                  orderData.depositdate != null
                                    ? orderData.depositdate
                                    : "-"}
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">
                                  Customer Name:
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {orderData.entityid != "" &&
                                  orderData.entityid != null
                                    ? orderData.entityid
                                    : "-"}
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">
                                  Contact Number:
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {orderData.phone != "" &&
                                  orderData.phone != null
                                    ? orderData.phone
                                    : "-"}
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">Email:</Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {orderData.email != "" &&
                                  orderData.email != null
                                    ? orderData.email
                                    : "-"}
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">Dropship:</Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {orderData.dropship != "" &&
                                  orderData.dropship != null
                                    ? orderData.dropship == 1
                                      ? "Yes"
                                      : "No"
                                    : "-"}
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">
                                  Customer Remark:
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {orderData.customer_remark != "" &&
                                  orderData.customer_remark != null
                                    ? orderData.customer_remark
                                    : "-"}
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">Sales Remark:</Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {orderData.sales_remark != "" &&
                                  orderData.sales_remark != null
                                    ? orderData.sales_remark
                                    : "-"}
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">Memo:</Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {orderData.memo != "" &&
                                  orderData.memo != null
                                    ? orderData.memo
                                    : "-"}
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">Polybag:</Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {orderData.polybag == 1 ? "Yes" : "No"}
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">Proceed By:</Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {orderData.proceed_by != "" &&
                                  orderData.proceed_by != null
                                    ? orderData.proceed_by
                                    : "-"}
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">Created By:</Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {orderData.created_person}
                                </Paragraph>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item xs={12} sm={12} md={6}>
                            <Grid
                              container
                              spacing={3}
                              sx={{ alignItems: "center" }}
                            >
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">Payment Type:</Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {orderData.paymenttype}
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">Currency:</Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {orderData.currency}
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">Status:</Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {orderData.status}
                                </Paragraph>
                              </Grid>
                              {orderData.status_id == "6" && (
                                <>
                                  <Grid item xs={12} sm={4} md={3}>
                                    <Paragraph size="14px">
                                      Cancel Date & Time:
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={12} sm={8} md={9}>
                                    <Paragraph size="14px" bold="600">
                                      {orderData.cancelled_date}
                                    </Paragraph>
                                  </Grid>
                                </>
                              )}
                              {showPaymentLink && (
                                <React.Fragment>
                                  {orderData.status_id == 6 ? (
                                    <></>
                                  ) : (
                                    <>
                                      <Grid item xs={12} sm={4} md={3}>
                                        <Paragraph size="14px">
                                          Payment Link:
                                        </Paragraph>
                                      </Grid>
                                      <Grid item xs={12} sm={8} md={9}>
                                        {paymentLink == null ? (
                                          <a
                                            onClick={() =>
                                              handleCreatePaymentLink()
                                            }
                                            target="_blank"
                                            style={{
                                              width: "fit-content",
                                              margin: "0 0 0 0",
                                              textDecoration: "none",
                                              borderRadius: "4px",
                                            }}
                                            className={
                                              classes.theCustomActionBtnFill_
                                            }
                                          >
                                            <Paragraph>
                                              Create Payment Link
                                            </Paragraph>
                                          </a>
                                        ) : (
                                          <a
                                            href={paymentLink}
                                            target="_blank"
                                            style={{
                                              width: "fit-content",
                                              margin: "0 0 10px",
                                              textDecoration: "underline",
                                            }}
                                          >
                                            <Paragraph>{paymentLink}</Paragraph>
                                          </a>
                                        )}
                                      </Grid>
                                    </>
                                  )}
                                </React.Fragment>
                              )}

                              {orderData.bankslip.length != 0 && (
                                <React.Fragment>
                                  <Grid item xs={12} sm={4} md={3}>
                                    <Paragraph size="14px">
                                      Bank Slip:
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={12} sm={8} md={9}>
                                    <div style={{ width: "30%" }}>
                                      <a
                                        href={orderData.bankslip}
                                        target="_blank"
                                        style={{
                                          backgroundColor: "rgb(26 83 134)",
                                          margin: "0 0 10px",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                        className={
                                          classes.theCustomActionBtnFill
                                        }
                                      >
                                        <Paragraph margin="6px 0" center>
                                          View
                                        </Paragraph>
                                      </a>
                                    </div>
                                    {orderData.is_deposit_paid == 0 && (
                                      <div style={{ width: "30%" }}>
                                        <a
                                          style={{
                                            backgroundColor: "#1A8649",
                                            margin: 0,
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                          }}
                                          className={
                                            classes.theCustomActionBtnFill
                                          }
                                          onClick={() => handleApproveDeposit()}
                                        >
                                          <Paragraph margin="6px 0">
                                            Approve
                                          </Paragraph>
                                        </a>
                                      </div>
                                    )}
                                  </Grid>
                                </React.Fragment>
                              )}
                              {orderData.consignment_note != "" && (
                                <React.Fragment>
                                  <Grid item xs={12} sm={4} md={3}>
                                    <Paragraph size="14px">
                                      Consignment Note:
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={12} sm={8} md={9}>
                                    <a
                                      href={orderData.consignment_note}
                                      target="_blank"
                                      style={{
                                        width: "fit-content",
                                        margin: "0 0 10px",
                                        textDecoration: "none",
                                      }}
                                      className={
                                        classes.theCustomActionBtnFill_
                                      }
                                    >
                                      <Paragraph>
                                        View Consignment Note
                                      </Paragraph>
                                    </a>
                                    {/* {orderData.status_id == 1 && (
                                      <a
                                        style={{
                                          width: 'fit-content',
                                          margin: '0 0 10px'
                                        }}
                                        className={
                                          classes.theCustomActionBtnFill_
                                        }
                                        onClick={() =>
                                          handleApproveConsignment()
                                        }
                                      >
                                        <Paragraph>
                                          Approve Consginment Note
                                        </Paragraph>
                                      </a>
                                    )} */}
                                  </Grid>
                                </React.Fragment>
                              )}
                              {orderData.status_id == 5 &&
                                orderData.file != "" && (
                                  <React.Fragment>
                                    <Grid item xs={12} sm={4} md={3}>
                                      <Paragraph size="14px">
                                        Invoice:
                                      </Paragraph>
                                    </Grid>
                                    <Grid item xs={12} sm={8} md={9}>
                                      <a
                                        href={orderData.file}
                                        target="_blank"
                                        style={{
                                          width: "fit-content",
                                          margin: "0 0 10px",
                                          textDecoration: "none",
                                        }}
                                        className={
                                          classes.theCustomActionBtnFill_
                                        }
                                      >
                                        <Paragraph>View Invoice</Paragraph>
                                      </a>
                                    </Grid>
                                  </React.Fragment>
                                )}
                              {orderData.status_id == 5 && (
                                <>
                                  {orderData.dolink != "" && (
                                    <>
                                      <Grid item xs={12} sm={4} md={3}>
                                        <Paragraph size="14px">
                                          Delivery Order:
                                        </Paragraph>
                                      </Grid>
                                      <Grid item xs={12} sm={8} md={9}>
                                        <a
                                          // href={orderData.do_link}
                                          onClick={() =>
                                            window.open(orderData.dolink)
                                          }
                                          // onClick={()=>handleDO()}
                                          target="_blank"
                                          style={{
                                            width: "fit-content",
                                            margin: "0 0 10px",
                                            textDecoration: "none",
                                          }}
                                          className={
                                            classes.theCustomActionBtnFill_
                                          }
                                        >
                                          <Paragraph>Delivery Order</Paragraph>
                                        </a>
                                      </Grid>
                                    </>
                                  )}
                                </>
                              )}
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">Syn Status:</Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {orderData.syn_status != ""
                                    ? orderData.syn_status
                                    : "-"}
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">Pick Status:</Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {orderData.picked == 1 ? "Yes" : "No"}
                                </Paragraph>
                              </Grid>
                              {/* <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">Sales Rep:</Paragraph>
                              </Grid>

                              <Grid item xs={12} sm={8} md={9}>
                                {orderData.internalid == 820 ? (
                                  <FormInputSelect
                                    textcolor="#707070"
                                    placeholder="Class"
                                    name="class"
                                    bg="#fff"
                                    border="1px solid #c5c5c5"
                                  >
                                    <Select
                                      displayEmpty
                                      inputProps={{
                                        "aria-label": "Without label",
                                      }}
                                      value={selectedRep}
                                      onChange={(e) =>
                                        setSelectedRep(e.target.value)
                                      }
                                      // style={{ marginBottom: "1rem" }}
                                    >
                                      {rep != null &&
                                        rep.map((res) => (
                                          <MenuItem
                                            value={res.internalid}
                                            style={{ color: "#000" }}
                                          >
                                            {res.entityid}
                                          </MenuItem>
                                        ))}
                                    </Select>
                                  </FormInputSelect>
                                ) : (
                                  <Paragraph size="14px" bold="600">
                                    {orderData.salesrep_name != "" &&
                                    orderData.salesrep_name != null
                                      ? orderData.salesrep_name
                                      : "-"}
                                  </Paragraph>
                                )}
                              </Grid> */}

                              {get_user().internalid == 117 ||
                              get_user().internalid == 820 ||
                              get_user().internalid == 0 ? (
                                <>
                                  <Grid item xs={12} sm={4} md={3}>
                                    <Paragraph size="14px">
                                      Sales Rep:
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={12} sm={8} md={9}>
                                    <FormInputSelect
                                      textcolor="#707070"
                                      placeholder="Class"
                                      name="class"
                                      bg="#fff"
                                      border="1px solid #c5c5c5"
                                    >
                                      <Select
                                        displayEmpty
                                        inputProps={{
                                          "aria-label": "Without label",
                                        }}
                                        value={selectedRep}
                                        onChange={(e) =>
                                          setSelectedRep(e.target.value)
                                        }
                                        // style={{ marginBottom: "1rem" }}
                                      >
                                        {rep != null &&
                                          rep.map((res) => (
                                            <MenuItem
                                              value={res.internalid}
                                              style={{ color: "#000" }}
                                            >
                                              {res.entityid}
                                            </MenuItem>
                                          ))}
                                      </Select>
                                    </FormInputSelect>
                                  </Grid>
                                </>
                              ) : (
                                <>
                                  <Grid item xs={12} sm={4} md={3}>
                                    <Paragraph size="14px">
                                      Sales Rep:
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={12} sm={8} md={9}>
                                    <Paragraph size="14px" bold="600">
                                      {orderData.salesrep_name != "" &&
                                      orderData.salesrep_name != null
                                        ? orderData.salesrep_name
                                        : "-"}
                                    </Paragraph>
                                  </Grid>
                                </>
                              )}

                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">
                                  Merchandiser:
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <FormInputSelect
                                  textcolor="#707070"
                                  placeholder="Select Merchandiser"
                                  name="merchandiser"
                                  bg="#fff"
                                  border="1px solid #c5c5c5"
                                >
                                  <Select
                                    displayEmpty
                                    inputProps={{
                                      "aria-label": "Without label",
                                    }}
                                    value={selectedMerchandiser}
                                    onChange={handleChangeMerchandiser}
                                  >
                                    {merchandiser != null &&
                                      merchandiser.map((res) => (
                                        <MenuItem
                                          value={res.internalid}
                                          style={{ color: "#000" }}
                                        >
                                          {res.entityid}
                                        </MenuItem>
                                      ))}
                                  </Select>
                                </FormInputSelect>
                              </Grid>

                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">Class:</Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {orderData.class != "" &&
                                  orderData.class != null
                                    ? orderData.class
                                    : "-"}
                                </Paragraph>
                              </Grid>
                              {orderData.status_id == 6 && (
                                <>
                                  <Grid item xs={12} sm={4} md={3}>
                                    <Paragraph size="14px">
                                      Cancelled by:
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={12} sm={8} md={9}>
                                    <Paragraph size="14px" bold="600">
                                      {orderData.cancelled_person != "" &&
                                      orderData.cancelled_person != null
                                        ? orderData.cancelled_person
                                        : "-"}
                                    </Paragraph>
                                  </Grid>
                                </>
                              )}
                            </Grid>
                          </Grid>
                        </Grid>
                        <br />
                        <br />
                        <div
                          style={{
                            borderBottom: "2px solid #707070",
                            padding: ".2rem 0",
                          }}
                        />
                        <br />
                        <Grid
                          container
                          spacing={3}
                          sx={{ alignItems: "center" }}
                        >
                          <Grid item xs={12} sm={12} md={6}>
                            <Grid
                              container
                              spacing={3}
                              sx={{ alignItems: "center" }}
                            >
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">
                                  Shipping Method:
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                {orderData?.status_id == 4 ||
                                orderData?.status_id == 5 ||
                                orderData?.status_id == 6 ? (
                                  <Paragraph size="14px" bold="600">
                                    {orderData.shippingmethod != "" &&
                                    orderData.shippingmethod != null
                                      ? orderData.shippingmethod
                                      : "-"}
                                  </Paragraph>
                                ) : (
                                  <FormInputSelect>
                                    <Select
                                      displayEmpty
                                      inputProps={{
                                        "aria-label": "Without label",
                                      }}
                                      value={_selectedShippingMethod}
                                      onChange={_handleChangeShippingMethod}
                                      // style={{ marginBottom: "1rem" }}
                                    >
                                      <MenuItem
                                        value=""
                                        style={{ fontWeight: "400" }}
                                      >
                                        <em style={{ color: "#878787" }}>
                                          Please Choose a Shipping Method
                                        </em>
                                      </MenuItem>
                                      {shippingMethod.map((item) => (
                                        <MenuItem
                                          value={item.shipping_method_id}
                                          style={{ color: "#000" }}
                                        >
                                          {item.shippingmethod}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormInputSelect>
                                )}
                              </Grid>
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">Tracking Ref:</Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {orderData.trackingref != ""
                                    ? orderData.trackingref
                                    : "-"}
                                </Paragraph>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item xs={12} sm={12} md={6}>
                            <Grid
                              container
                              spacing={3}
                              sx={{ alignItems: "center" }}
                            >
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">
                                  Shipping Carrier:
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                {orderData?.status_id == 4 ||
                                orderData?.status_id == 5 ||
                                orderData?.status_id == 6 ? (
                                  <Paragraph size="14px" bold="600">
                                    {orderData.shippingcarrier != "" &&
                                    orderData.shippingcarrier != null
                                      ? orderData.shippingcarrier
                                      : "-"}
                                  </Paragraph>
                                ) : (
                                  <FormInputSelect
                                    disabled={
                                      _shippingCarrier.length == 0 ? true : false
                                    }
                                    bg={
                                      _shippingCarrier.length == 0
                                        ? "#C5C5C5"
                                        : "#FFF"
                                    }
                                  >
                                    <Select
                                      displayEmpty
                                      inputProps={{
                                        "aria-label": "Without label",
                                      }}
                                      value={_selectedShippingCarrier}
                                      onChange={_handleChangeShippingCarrier}
                                      disabled={
                                        _shippingCarrier.length == 0
                                      }
                                      // style={{ marginBottom: "1rem" }}
                                    >
                                      {_shippingCarrier.map((item) => (
                                        <MenuItem
                                          value={item.shipping_carrier_id}
                                          style={{ color: "#000" }}
                                        >
                                          {item.shippingcarrier}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormInputSelect>
                                )}
                              </Grid>

                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">
                                  Number of Packs:
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {orderData.item_fulfilment != ""
                                    ? orderData.item_fulfilment
                                    : "-"}
                                </Paragraph>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                        <br />
                        <div
                          style={{
                            borderBottom: "2px solid #707070",
                            padding: ".2rem 0",
                          }}
                        />
                        <br />
                        <Grid
                          container
                          spacing={3}
                          // sx={{ alignItems: "center" }}
                        >
                          <Grid item xs={12} sm={12} md={6}>
                            <Grid container spacing={3}>
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">
                                  Billing Address:
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {orderData.billing_addr1}
                                </Paragraph>
                                <Paragraph size="14px" bold="600">
                                  {orderData.billing_addr2}
                                </Paragraph>
                                <Paragraph size="14px" bold="600">
                                  {orderData.billing_city}{" "}
                                  {orderData.billing_zip}{" "}
                                  {orderData.billing_state}{" "}
                                  {orderData.billing_country}
                                </Paragraph>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item xs={12} sm={12} md={6}>
                            <Grid container spacing={3}>
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">
                                  Shipping Address:
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                {orderData?.status_id == 4 ||
                                orderData?.status_id == 5 ||
                                orderData?.status_id == 6 ? (
                                  <>
                                    <Paragraph size="14px" bold="600">
                                      {orderData.addr1}
                                    </Paragraph>
                                    <Paragraph size="14px" bold="600">
                                      {orderData.addr2}
                                    </Paragraph>
                                    <Paragraph size="14px" bold="600">
                                      {orderData.city} {orderData.zip}{" "}
                                      {orderData.state} {orderData.country}
                                    </Paragraph>
                                  </>
                                ) : (
                                  <FormInputSelect>
                                    <Select
                                      displayEmpty
                                      inputProps={{
                                        "aria-label": "Without label",
                                      }}
                                      // name="name"
                                      value={_selectedCustomerAddress}
                                      onChange={_handleChooseCustomerAddress}
                                      style={{ marginBottom: "1rem" }}
                                    >
                                      <MenuItem
                                        value=""
                                        style={{ fontWeight: "400" }}
                                      >
                                        <em style={{ color: "#878787" }}>
                                          Please Choose a Shipping Address
                                        </em>
                                      </MenuItem>
                                      {customerAddrsssList.map((item) => (
                                        <MenuItem
                                          value={item.customer_address_id}
                                          style={{ color: "#000" }}
                                        >
                                          {item.addr1}, {item.add2},{item.city},
                                          {item.zip},{item.state},{item.country}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormInputSelect>
                                )}
                              </Grid>
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">Contact Name:</Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                {orderData.contact_name != "" &&
                                orderData.contact_name != null
                                  ? orderData.contact_name
                                  : "-"}
                              </Grid>
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">
                                  Contact Number:
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                {orderData.contact_number != "" &&
                                orderData.contact_number != null
                                  ? orderData.contact_number
                                  : "-"}
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>

                        <br />

                        <React.Fragment>
                          <div
                            style={{
                              borderBottom: "2px solid #707070",
                              padding: ".2rem 0",
                            }}
                          />
                          <br />
                          <Grid container spacing={3}>
                            {/* <Grid item xs={12} sm={12} md={6}>
                            <FormInput
                              label='Class'
                              value={selectedClass}
                              textcolor='#707070'
                              placeholder='Class'
                              name='class'
                              bg='#fff'
                              border='1px solid #c5c5c5'
                              select
                              onChange={e => setSelectedClass(e.target.value)}
                            >
                              {classList != null &&
                                classList.map(res => (
                                  <MenuItem value={res.class} style={{ color: '#000' }}>
                                    {res.name}
                                  </MenuItem>
                                ))}
                            </FormInput>
                          </Grid> */}
                            <Grid item xs={12} sm={12} md={6}>
                              {orderData.status_id == 1 && (
                                <FormInput
                                  label="Shipping Fee"
                                  value={shippingFee}
                                  textcolor="#707070"
                                  placeholder="Shipping Fee"
                                  name="shippingFee"
                                  bg="#fff"
                                  border="1px solid #c5c5c5"
                                  type="number"
                                  inputProps={{ min: 0 }}
                                  onKeyDown={(e) =>
                                    e.key === "Enter" &&
                                    setShippingFee(
                                      parseFloat(shippingFee).toFixed(2)
                                    )
                                  }
                                  onBlur={() =>
                                    setShippingFee(
                                      parseFloat(shippingFee).toFixed(2)
                                    )
                                  }
                                  onChange={(e) =>
                                    setShippingFee(e.target.value)
                                  }
                                />
                              )}
                              {/* <FormInput
                                  label='Handling Fee'
                                  value={handlingFee}
                                  textcolor='#707070'
                                  placeholder='Handling Fee'
                                  name='handlingfee'
                                  bg='#c5c5c5'
                                  border='1px solid #c5c5c5'
                                  type='number'
                                  inputProps={{ min: 0 }}
                                  onChange={e => setHandlingFee(e.target.value)}
                                  disabled
                                /> */}


                              <React.Fragment>
                                <Paragraph margin=".4rem 0">
                                  Customer Po Form:
                                </Paragraph>

                                {orderData.customorderpo != "" ? (
                                  <a
                                    href={orderData.customorderpo}
                                    target="_blank"
                                  >
                                    <Paragraph margin="0 0 .4rem">
                                      View Customer Po Form
                                    </Paragraph>
                                  </a>
                                ) : (
                                  <Paragraph margin="0 0 .4rem">
                                    No Customer Po Form Yet
                                  </Paragraph>
                                )}

                                {/* <input
                                      className="ori-fileinput"
                                      type="file"
                                      name="customerpo"
                                      style={
                                        {
                                          // opacity: 0,
                                          // top: "0",
                                          // position: "absolute"
                                        }
                                      }
                                      onChange={handleCaptureSingle}
                                    /> */}
                                <div
                                  {...customerpoDropzone.getRootProps({
                                    className: "dropzone",
                                  })}
                                  style={dropzone}
                                >
                                  <input
                                    {...customerpoDropzone.getInputProps()}
                                  />
                                  <p>
                                    Drag 'n' drop some files here, or click to
                                    select files
                                  </p>
                                </div>
                                <>
                                  {files2 == [] ? (
                                    <div
                                      {...customerpoDropzone.getRootProps({})}
                                    >
                                      <input
                                        {...customerpoDropzone.getInputProps()}
                                        name="customerpo"
                                      />
                                    </div>
                                  ) : (
                                    <>
                                      <div>{thumbs2}</div>
                                      {/* {fileRejectionItems} */}
                                    </>
                                  )}
                                </>
                                <Paragraph size="14px" margin=" 0">
                                  *Leave blank if not editing
                                </Paragraph>
                              </React.Fragment>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6}>
                              {orderData.status_id == 1 && (
                                <FormInput
                                  label="Deposit"
                                  value={deposit}
                                  textcolor="#707070"
                                  placeholder="Deposit"
                                  name="deposit"
                                  bg="#fff"
                                  border="1px solid #c5c5c5"
                                  type="number"
                                  inputProps={{ min: 0 }}
                                  onKeyDown={(e) =>
                                    e.key === "Enter" &&
                                    setDeposit(parseFloat(deposit).toFixed(2))
                                  }
                                  onBlur={() =>
                                    setDeposit(parseFloat(deposit).toFixed(2))
                                  }
                                  onChange={(e) => setDeposit(e.target.value)}
                                />
                              )}
                              {orderData.status_id == 1 && (
                                <FormInput
                                  label="Sales Remark"
                                  value={remark.sales_remark}
                                  textcolor="#707070"
                                  placeholder="Sales Remark"
                                  name="sales_remark"
                                  bg="#fff"
                                  border="1px solid #c5c5c5"
                                  onChange={handleChangeRemark}
                                />
                              )}
                              {orderData.status_id == 1 && (
                                <FormInput
                                  label="Customer Remark"
                                  value={remark.customer_remark}
                                  textcolor="#707070"
                                  placeholder="Customer Remark"
                                  name="customer_remark"
                                  bg="#fff"
                                  border="1px solid #c5c5c5"
                                  onChange={handleChangeRemark}
                                />
                              )}
                              {orderData.status_id == 1 && (
                                <FormInput
                                  label="Memo"
                                  value={remark.memo}
                                  textcolor="#707070"
                                  placeholder="Memo"
                                  name="memo"
                                  bg="#fff"
                                  border="1px solid #c5c5c5"
                                  onChange={handleChangeRemark}
                                />
                              )}
                              {orderData.status_id == 1 && (
                                <React.Fragment>
                                  {orderData !== null &&
                                    orderData.paymenttype == "Credit" && (
                                      <React.Fragment>
                                        <Paragraph margin=".4rem 0">
                                          Bypass Credit Limit
                                        </Paragraph>
                                        <Checkbox
                                          onChange={() =>
                                            setRemark({
                                              ...remark,
                                              bypasscl: !remark.bypasscl,
                                            })
                                          }
                                          checked={remark.bypasscl}
                                          sx={{
                                            padding: "0 .4rem 0 0",
                                            color: "#1A5386 ",
                                            "&.Mui-checked": {
                                              color: "#1A5386 ",
                                            },
                                          }}
                                        />
                                        {remark.bypasscl ? "Yes" : "No"}
                                      </React.Fragment>
                                    )}
                                </React.Fragment>
                              )}
                              <Paragraph margin=".4rem 0">
                                Attachment:
                              </Paragraph>
                              {orderData.attachment != "" ? (
                                <a href={orderData.attachment} target="_blank">
                                  <Paragraph margin="0 0 .4rem">
                                    View Attachment
                                  </Paragraph>
                                </a>
                              ) : (
                                <Paragraph margin="0 0 .4rem">
                                  No Attachment Yet
                                </Paragraph>
                              )}

                              <div
                                {...attachmentDropzone.getRootProps({
                                  className: "dropzone",
                                })}
                                style={dropzone}
                              >
                                <input
                                  {...attachmentDropzone.getInputProps()}
                                />
                                <p>
                                  Drag 'n' drop some files here, or click to
                                  select files
                                </p>
                              </div>
                              <>
                                {files == [] ? (
                                  <div {...attachmentDropzone.getRootProps({})}>
                                    <input
                                      {...attachmentDropzone.getInputProps()}
                                      name="attachment"
                                    />
                                  </div>
                                ) : (
                                  <>
                                    <div>{thumbs}</div>
                                    {/* {fileRejectionItems} */}
                                  </>
                                )}
                              </>
                              <Paragraph size="14px" margin=" 0">
                                *Leave blank if not editing
                              </Paragraph>
                            </Grid>
                          </Grid>

                          <div
                            className={classes.theFlexBtn}
                            style={{ marginBottom: "0" }}
                          >
                            <React.Fragment>
                              <a
                                style={{ backgroundColor: "#1A8649" }}
                                className={classes.theCustomActionBtnFill}
                                onClick={() => handleSaveDetail()}
                              >
                                <Save sx={{ color: "#fff" }} />
                                <Paragraph margin="0 0 0 .4rem">Save</Paragraph>
                              </a>
                            </React.Fragment>
                          </div>

                          <div
                            ref={OrderProductRef}
                            style={{
                              borderBottom: "2px solid #707070",
                              padding: ".2rem 0",
                            }}
                          />
                          <br />
                        </React.Fragment>
                        <br />

                        <div>
                          <Grid container spacing={3}>
                            <Grid item xs={12} sm={12} md={12}>
                              <Card className={classes.theCard}>
                                <div className={classes.theFlexHeader}>
                                  <Paragraph
                                    color="#1A5386"
                                    size="14px"
                                    bold="600"
                                  >
                                    Product List
                                  </Paragraph>
                                  <div
                                    className={classes.theFlexBtn}
                                    style={{ marginBottom: "0" }}
                                  >
                                    {loadingItem ? (
                                      <div style={{ margin: "auto" }}>
                                        <Loader
                                          type="bubble-loop"
                                          bgColor="#1A5386"
                                          size={50}
                                        />
                                      </div>
                                    ) : (
                                      <React.Fragment>
                                        {orderData.status_id == 1 && (
                                          <a
                                            style={{
                                              border: 0,
                                              backgroundColor: "#1A5386",
                                              borderRadius: "10px",
                                            }}
                                            className={
                                              classes.theCustomActionBtn
                                            }
                                            onClick={() => {
                                              setPage("product");
                                              window.scrollTo({
                                                top: 0,
                                                behavior: "smooth",
                                              });
                                            }}
                                          >
                                            <AddCircle sx={{ color: "#fff" }} />
                                            <Paragraph
                                              size="16px"
                                              color="#fff"
                                              margin="0 0 0 .4rem"
                                            >
                                              Add Item
                                            </Paragraph>
                                          </a>
                                        )}
                                        {orderData.status_id == 2 && (
                                          <a
                                            style={{
                                              border: 0,
                                              backgroundColor: "#1A5386",
                                              borderRadius: "10px",
                                            }}
                                            className={
                                              classes.theCustomActionBtn
                                            }
                                            onClick={() => {
                                              setPage("product");
                                              window.scrollTo({
                                                top: 0,
                                                behavior: "smooth",
                                              });
                                            }}
                                          >
                                            <AddCircle sx={{ color: "#fff" }} />
                                            <Paragraph
                                              size="16px"
                                              color="#fff"
                                              margin="0 0 0 .4rem"
                                            >
                                              Add Item
                                            </Paragraph>
                                          </a>
                                        )}
                                      </React.Fragment>
                                    )}
                                  </div>
                                </div>
                                <br />
                                <div
                                  style={{
                                    borderBottom: "2px solid #707070",
                                  }}
                                ></div>
                                <br />
                                <TableContainer>
                                  <Table>
                                    <TableHead
                                      style={{ backgroundColor: "#fff" }}
                                    >
                                      <TableRow>
                                        {/* <TableCell
                                          style={{
                                            borderRadius: '10px 0 0 10px'
                                          }}
                                          className={classes.theHeadTitle_}
                                        >
                                          HS Code
                                        </TableCell> */}
                                        <TableCell
                                          className={classes.theHeadTitle_}
                                        >
                                          Item Name
                                        </TableCell>
                                        <TableCell
                                          className={classes.theHeadTitle_}
                                        >
                                          Description
                                        </TableCell>
                                        <TableCell
                                          className={classes.theHeadTitle_}
                                        >
                                          Attributes
                                        </TableCell>
                                        {/* <TableCell className={classes.theHeadTitle_}>
                                                                        Size
                                                                    </TableCell>
                                                                    <TableCell className={classes.theHeadTitle_}>
                                                                        Price Level
                                                                    </TableCell> */}
                                        <TableCell
                                          className={classes.theHeadTitle_}
                                          sx={{ textAlign: "right" }}
                                        >
                                          Price
                                        </TableCell>
                                        <TableCell
                                          className={classes.theHeadTitle_}
                                          sx={{ textAlign: "right" }}
                                        >
                                          Discount Amount
                                        </TableCell>
                                        <TableCell
                                          className={classes.theHeadTitle_}
                                          sx={{ textAlign: "right" }}
                                        >
                                          Quantity
                                        </TableCell>
                                        <TableCell
                                          className={classes.theHeadTitle_}
                                          sx={{ textAlign: "right" }}
                                        >
                                          Total Price
                                        </TableCell>
                                        {orderData.status_id == 1 && (
                                          <TableCell
                                            align="center"
                                            style={{
                                              borderRadius: "0 10px 10px 0",
                                            }}
                                            className={classes.theHeadTitle_}
                                          >
                                            <MoreVert sx={{ color: "#000" }} />
                                          </TableCell>
                                        )}
                                        {orderData.status_id == 2 && (
                                          <TableCell
                                            align="center"
                                            style={{
                                              borderRadius: "0 10px 10px 0",
                                            }}
                                            className={classes.theHeadTitle_}
                                          >
                                            <MoreVert sx={{ color: "#000" }} />
                                          </TableCell>
                                        )}
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {orderData.item.map((item, index) => {
                                        // if (searchKey != "") {
                                        //     if (
                                        //         item.supplier &&
                                        //         item.name
                                        //             .toUpperCase()
                                        //             .indexOf(searchKey.toUpperCase()) <= -1
                                        //     ) {
                                        //         return;
                                        //     }
                                        // }
                                        return (
                                          <React.Fragment>
                                            {item.is_display == 1 && (
                                              <TableRow>
                                                {/* <TableCell
                                                  style={{
                                                    background:
                                                      index % 2 == 0
                                                        ? '#E0F0F7'
                                                        : '#fff',
                                                    width: '10%'
                                                  }}
                                                >
                                                  {item.hscode != '' &&
                                                    item.hscode != null
                                                    ? item.hscode
                                                    : '-'}
                                                </TableCell> */}
                                                <TableCell
                                                  style={{
                                                    background:
                                                      index % 2 == 0
                                                        ? "#E0F0F7"
                                                        : "#fff",
                                                    width: "8%",
                                                  }}
                                                >
                                                  {item.itemname != "" &&
                                                  item.itemname != null
                                                    ? item.itemname
                                                    : "-"}
                                                </TableCell>
                                                <TableCell
                                                  style={{
                                                    background:
                                                      index % 2 == 0
                                                        ? "#E0F0F7"
                                                        : "#fff",
                                                    width: "25%",
                                                  }}
                                                >
                                                  {item.displyname != "" ? (
                                                    <pre
                                                      style={{
                                                        margin: 0,
                                                        fontFamily:
                                                          "Roboto,Helvetica, Arial",
                                                        whiteSpace: "pre-line",
                                                      }}
                                                    >
                                                      {item.displayname}
                                                    </pre>
                                                  ) : (
                                                    <></>
                                                  )}

                                                  <pre
                                                    style={{
                                                      margin: 0,
                                                      fontFamily:
                                                        "Roboto,Helvetica, Arial",
                                                      whiteSpace: "pre-line",
                                                      fontStyle: "italic",
                                                      fontWeight: "600",
                                                      color: "#1a5386",
                                                    }}
                                                  >
                                                    {item.description != "" &&
                                                    item.description != null
                                                      ? item.description
                                                      : ""}
                                                  </pre>
                                                </TableCell>
                                                <TableCell
                                                  style={{
                                                    background:
                                                      index % 2 == 0
                                                        ? "#E0F0F7"
                                                        : "#fff",
                                                    width: "10%",
                                                  }}
                                                >
                                                  Clr:{" "}
                                                  {item.color != "" &&
                                                  item.color != null
                                                    ? item.color
                                                    : "-"}
                                                  <div>
                                                    Sz:{" "}
                                                    {item.size != "" &&
                                                    item.size != null
                                                      ? item.size
                                                      : "-"}
                                                  </div>
                                                </TableCell>
                                                {/* <TableCell style={{ background: "#E0F0F7" }}>
                                                                                    {item.size}
                                                                                </TableCell>
                                                                                <TableCell style={{ background: "#E0F0F7" }}>
                                                                                    {item.pricelevel}
                                                                                </TableCell> */}
                                                <TableCell
                                                  style={{
                                                    background:
                                                      index % 2 == 0
                                                        ? "#E0F0F7"
                                                        : "#fff",
                                                    width: "10%",
                                                    textAlign: "right",
                                                  }}
                                                >
                                                  {item.price}
                                                </TableCell>
                                                <TableCell
                                                  style={{
                                                    background:
                                                      index % 2 == 0
                                                        ? "#E0F0F7"
                                                        : "#fff",
                                                    // width: "10%",
                                                    textAlign: "right",
                                                  }}
                                                >
                                                  {item.discountamount}
                                                </TableCell>
                                                <TableCell
                                                  style={{
                                                    background:
                                                      index % 2 == 0
                                                        ? "#E0F0F7"
                                                        : "#fff",
                                                    width: "10%",
                                                    textAlign: "right",
                                                  }}
                                                >
                                                  {item.quantity}
                                                </TableCell>
                                                <TableCell
                                                  style={{
                                                    background:
                                                      index % 2 == 0
                                                        ? "#E0F0F7"
                                                        : "#fff",
                                                    width: "10%",
                                                    textAlign: "right",
                                                  }}
                                                >
                                                  {item.subtotal}
                                                </TableCell>
                                                {orderData.status_id == 1 && (
                                                  <TableCell
                                                    align="center"
                                                    style={{
                                                      background:
                                                        index % 2 == 0
                                                          ? "#E0F0F7"
                                                          : "#fff",
                                                      width: "10%",
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        background: "#1A5386",
                                                        display: "flex",
                                                        justifyContent:
                                                          "center",
                                                        alignItmes: "center",
                                                        padding: "10px 0",
                                                        borderRadius: "10px",
                                                        margin: "0 0 10px",
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={() =>
                                                        handleOpen(item)
                                                      }
                                                    >
                                                      <Edit
                                                        sx={{ color: "#fff" }}
                                                      />
                                                    </div>
                                                    <div
                                                      style={{
                                                        background: "#1A5386",
                                                        display: "flex",
                                                        justifyContent:
                                                          "center",
                                                        alignItmes: "center",
                                                        padding: "10px 0",
                                                        borderRadius: "10px",
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={() =>
                                                        handleOpenDelete(item)
                                                      }
                                                    >
                                                      <Delete
                                                        sx={{ color: "#fff" }}
                                                      />
                                                    </div>
                                                  </TableCell>
                                                )}
                                                {orderData.status_id == 2 && (
                                                  <TableCell
                                                    align="center"
                                                    style={{
                                                      background:
                                                        index % 2 == 0
                                                          ? "#E0F0F7"
                                                          : "#fff",
                                                      width: "10%",
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        background: "#1A5386",
                                                        display: "flex",
                                                        justifyContent:
                                                          "center",
                                                        alignItmes: "center",
                                                        padding: "10px 0",
                                                        borderRadius: "10px",
                                                        margin: "0 0 10px",
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={() =>
                                                        handleOpen(item)
                                                      }
                                                    >
                                                      <Edit
                                                        sx={{ color: "#fff" }}
                                                      />
                                                    </div>
                                                    <div
                                                      style={{
                                                        background: "#1A5386",
                                                        display: "flex",
                                                        justifyContent:
                                                          "center",
                                                        alignItmes: "center",
                                                        padding: "10px 0",
                                                        borderRadius: "10px",
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={() =>
                                                        handleOpenDelete(item)
                                                      }
                                                    >
                                                      <Delete
                                                        sx={{ color: "#fff" }}
                                                      />
                                                    </div>
                                                  </TableCell>
                                                )}
                                              </TableRow>
                                            )}
                                          </React.Fragment>
                                        );
                                      })}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                                <br />
                                <div
                                  style={{
                                    borderBottom: "2px solid #f2f2f2",
                                  }}
                                ></div>
                                <br />
                                <Grid container spacing={3}>
                                  <Grid item xs={12} sm={6}></Grid>
                                  <Grid item xs={12} sm={6}>
                                    <div className={classes.theTotal}>
                                      <Grid container spacing={3}>
                                        <Grid item xs={6} sm={6} md={6}>
                                          <Paragraph size="14px">
                                            Amount:
                                          </Paragraph>
                                        </Grid>
                                        <Grid item xs={6} sm={6} md={6}>
                                          <Paragraph
                                            size="14px"
                                            bold="600"
                                            style={{ textAlign: "right" }}
                                          >
                                            {orderData.total_amount}
                                          </Paragraph>
                                        </Grid>
                                        <Grid item xs={6} sm={6} md={6}>
                                          <Paragraph size="14px">
                                            Discount Amount:
                                          </Paragraph>
                                        </Grid>
                                        <Grid item xs={6} sm={6} md={6}>
                                          <Paragraph
                                            size="14px"
                                            bold="600"
                                            style={{ textAlign: "right" }}
                                          >
                                            {/* {orderFee.final_amount} */}
                                            {orderData.discountamount}
                                          </Paragraph>
                                        </Grid>
                                        <Grid item xs={6} sm={6} md={6}>
                                          <Paragraph size="14px">
                                            Shipping Fee:
                                          </Paragraph>
                                        </Grid>
                                        <Grid item xs={6} sm={6} md={6}>
                                          <Paragraph
                                            size="14px"
                                            bold="600"
                                            style={{ textAlign: "right" }}
                                          >
                                            {shippingFee}
                                          </Paragraph>
                                        </Grid>
                                        <Grid item xs={6} sm={6} md={6}>
                                          <Paragraph size="14px">
                                            Handling Fee:
                                          </Paragraph>
                                        </Grid>
                                        <Grid item xs={6} sm={6} md={6}>
                                          <Paragraph
                                            size="14px"
                                            bold="600"
                                            style={{ textAlign: "right" }}
                                          >
                                            {handlingFee}
                                          </Paragraph>
                                        </Grid>
                                      </Grid>
                                    </div>
                                    <br />
                                    <div
                                      style={{
                                        borderBottom: "2px solid #f2f2f2",
                                      }}
                                    ></div>
                                    <br />
                                    <div className={classes.theTotal}>
                                      <Grid container spacing={3}>
                                        <React.Fragment>
                                          <Grid item xs={6} sm={6} md={6}>
                                            <Paragraph size="14px">
                                              {/* {orderData.sst > 0 ? "SST" : "GST"} */}
                                              {orderData.currency == "MYR" ? (
                                                <>SST</>
                                              ) : (
                                                <>GST</>
                                              )}
                                            </Paragraph>
                                          </Grid>
                                          <Grid item xs={6} sm={6} md={6}>
                                            <Paragraph
                                              size="14px"
                                              bold="600"
                                              style={{ textAlign: "right" }}
                                            >
                                              {orderFee.tax_fee}
                                            </Paragraph>
                                          </Grid>
                                        </React.Fragment>
                                        <Grid item xs={6} sm={6} md={6}>
                                          <Paragraph size="14px">
                                            Total:
                                          </Paragraph>
                                        </Grid>
                                        <Grid item xs={6} sm={6} md={6}>
                                          <Paragraph
                                            size="14px"
                                            bold="600"
                                            style={{ textAlign: "right" }}
                                          >
                                            {/* {orderFee.final_amount} */}
                                            {orderData.final_amount}
                                          </Paragraph>
                                        </Grid>
                                      </Grid>
                                    </div>
                                    <br />
                                    <div
                                      style={{
                                        borderBottom: "2px solid #f2f2f2",
                                      }}
                                    ></div>
                                    <br />
                                    <div className={classes.theTotal}>
                                      <Grid container spacing={3}>
                                        <Grid item xs={6} sm={6} md={6}>
                                          <Paragraph
                                            color={
                                              orderData.is_deposit_paid == 0 &&
                                              orderData.deposit_amount > 0
                                                ? "#C52626"
                                                : "#000"
                                            }
                                            size="14px"
                                            bold="bold"
                                          >
                                            Deposit:
                                          </Paragraph>
                                        </Grid>
                                        <Grid item xs={6} sm={6} md={6}>
                                          <Paragraph
                                            size="14px"
                                            bold="bold"
                                            color={
                                              orderData.is_deposit_paid == 0 &&
                                              orderData.deposit_amount > 0
                                                ? "#C52626"
                                                : "#000"
                                            }
                                            style={{ textAlign: "right" }}
                                          >
                                            {orderData.deposit_amount}
                                          </Paragraph>
                                        </Grid>
                                        {customerType == "Cash" && (
                                          <>
                                            <Grid item xs={6} sm={6} md={6}>
                                              <Paragraph
                                                // color={orderData.is_deposit_paid == 0 && orderData.deposit_amount > 0 ? "#C52626" : "#000"}
                                                size="14px"
                                                bold="bold"
                                              >
                                                Cash Balance:
                                              </Paragraph>
                                            </Grid>
                                            <Grid item xs={6} sm={6} md={6}>
                                              <Paragraph
                                                // color={orderData.is_deposit_paid == 0 && orderData.deposit_amount > 0 ? "#C52626" : "#000"}
                                                size="14px"
                                                bold="bold"
                                                style={{ textAlign: "right" }}
                                              >
                                                {/* {orderFee.final_amount} */}
                                                {orderData.cashbalance}
                                              </Paragraph>
                                            </Grid>
                                          </>
                                        )}

                                        <Grid item xs={6} sm={6} md={6}>
                                          <Paragraph
                                            // color={orderData.is_deposit_paid == 0 && orderData.deposit_amount > 0 ? "#C52626" : "#000"}
                                            size="14px"
                                            bold="bold"
                                          >
                                            Outstanding:
                                          </Paragraph>
                                        </Grid>
                                        <Grid item xs={6} sm={6} md={6}>
                                          <Paragraph
                                            // color={orderData.is_deposit_paid == 0 && orderData.deposit_amount > 0 ? "#C52626" : "#000"}
                                            size="14px"
                                            bold="bold"
                                            style={{ textAlign: "right" }}
                                          >
                                            {/* {orderFee.final_amount} */}
                                            {orderData.outstanding_amount}
                                          </Paragraph>
                                        </Grid>
                                        <br />
                                        <Grid item xs={6} sm={6} md={6}>
                                          <Paragraph
                                            // color={orderData.is_deposit_paid == 0 && orderData.deposit_amount > 0 ? "#C52626" : "#000"}
                                            size="14px"
                                            bold="bold"
                                          >
                                            Remaining Amount:
                                          </Paragraph>
                                        </Grid>
                                        <Grid item xs={6} sm={6} md={6}>
                                          <Paragraph
                                            // color={orderData.is_deposit_paid == 0 && orderData.deposit_amount > 0 ? "#C52626" : "#000"}
                                            size="14px"
                                            bold="bold"
                                            style={{ textAlign: "right" }}
                                          >
                                            {/* {orderFee.final_amount} */}
                                            {orderData.remainingamt}
                                          </Paragraph>
                                        </Grid>
                                      </Grid>
                                    </div>
                                  </Grid>
                                </Grid>
                              </Card>
                              <br />
                              <br />
                            </Grid>
                          </Grid>
                        </div>
                        <br />
                        <br />
                      </div>

                      <Dialog
                        onClose={handleCloseJson}
                        open={openJson}
                        fullWidth="true"
                        maxWidth="sm"
                      >
                        <DialogTitle>
                          <Paragraph
                            color="#1A5386"
                            bold="600"
                            size="24px"
                            center
                          >
                            Json Data
                          </Paragraph>
                        </DialogTitle>
                        <DialogContent>
                          <div
                            onClick={() => {
                              navigator.clipboard.writeText(jsonData);
                              toast("Copy succesfully");
                            }}
                          >
                            <Paragraph color="#1A5386" bold="400" size="14px">
                              {jsonData != null && jsonData}
                            </Paragraph>
                          </div>
                        </DialogContent>
                      </Dialog>

                      <Dialog
                        onClose={handleClose}
                        open={open}
                        fullWidth="true"
                        maxWidth="sm"
                      >
                        <DialogTitle>
                          <Paragraph
                            color="#1A5386"
                            bold="600"
                            size="24px"
                            center
                          >
                            Enter Edit Detail
                          </Paragraph>
                        </DialogTitle>
                        <DialogContent>
                          <div className={classes.theQuantityBox}>
                            <RemoveCircle
                              sx={{ fontSize: "2rem", color: "#1A5386" }}
                              onClick={() =>
                                selectedItem.quantity > 1 &&
                                setSelectedItem({
                                  ...selectedItem,
                                  quantity: parseInt(selectedItem.quantity) - 1,
                                })
                              }
                            />
                            <div className={classes.theQuantityField}>
                              <FormInput
                                value={
                                  selectedItem !== null &&
                                  parseInt(selectedItem.quantity)
                                }
                                textLabelColor="#000"
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                                type="number"
                                inputProps={{ min: 1 }}
                                name="quantity"
                                border="1px solid #c5c5c5"
                                mb="0"
                                center
                                onChange={handleChangeProduct2}
                              />
                            </div>
                            <AddCircle
                              onClick={() =>
                                setSelectedItem({
                                  ...selectedItem,
                                  quantity: parseInt(selectedItem.quantity) + 1,
                                })
                              }
                              sx={{ fontSize: "2rem", color: "#1A5386" }}
                            />
                          </div>
                          <div className={classes.theQuantityBox}>
                            <div className={classes.theQuantityField}>
                              <FormInput
                                value={
                                  selectedItem !== null && selectedItem.price
                                }
                                textLabelColor="#000"
                                disabled={
                                  selectedItem != null &&
                                  selectedItem.type != "Matrix Item"
                                    ? false
                                    : true
                                }
                                name="price"
                                placeholder="Price"
                                type="number"
                                border="1px solid #c5c5c5"
                                mb="0"
                                onChange={handleChangeProduct}
                              />
                            </div>
                          </div>
                          <div className={classes.theQuantityBox}>
                            <div className={classes.theQuantityField}>
                              <FormInput
                                value={
                                  selectedItem !== null &&
                                  selectedItem.given_discount
                                }
                                textLabelColor="#000"
                                name="given_discount"
                                placeholder="Discount Amount"
                                border="1px solid #c5c5c5"
                                mb="0"
                                type="number"
                                onChange={handleChangeProduct}
                              />
                            </div>
                          </div>
                          <div className={classes.theQuantityBox}>
                            <div className={classes.theQuantityField}>
                              <FormInput
                                value={
                                  selectedItem !== null &&
                                  selectedItem.description
                                }
                                textLabelColor="#000"
                                name="description"
                                placeholder="Description"
                                border="1px solid #c5c5c5"
                                mb="0"
                                multiline
                                minRows={4}
                                onChange={handleChangeProduct}
                              />
                            </div>
                          </div>
                          <div className={classes.theQuantityBox}>
                            <div className={classes.theQuantityField}>
                              <Button
                                onClick={() => handleSubmitEdit()}
                                label="Confirm"
                                color="#fff"
                                bg="#1A5386"
                                size="18px"
                                pd="10px"
                                br="5px"
                                style={{ marginBottom: "10px" }}
                              />
                            </div>
                          </div>
                        </DialogContent>
                      </Dialog>

                      <Dialog
                        onClose={handleCloseDelete}
                        open={openDelete}
                        fullWidth="true"
                        maxWidth="sm"
                      >
                        <DialogTitle>
                          <Paragraph color="#1A5386" bold="600" size="24px">
                            Delete Item
                          </Paragraph>
                        </DialogTitle>
                        <DialogContent>
                          <Paragraph
                            color="#000"
                            bold="600"
                            size="16px"
                            margin="0 0 1rem"
                          >
                            Are you sure to delete this item?
                          </Paragraph>
                          <Button
                            onClick={() => handleDeleteItem()}
                            label="Confirm"
                            color="#fff"
                            bg="#1A5386"
                            size="18px"
                            pd="10px"
                            br="5px"
                            style={{ marginBottom: "10px" }}
                          />
                        </DialogContent>
                      </Dialog>

                      <Dialog
                        onClose={() => setOpenType(false)}
                        open={openType}
                        fullWidth="true"
                        maxWidth="sm"
                      >
                        <DialogTitle>
                          <Paragraph
                            color="#1A5386"
                            bold="600"
                            size="24px"
                            center
                          >
                            Choose Return Type
                          </Paragraph>
                        </DialogTitle>
                        <DialogContent>
                          <div className={classes.theQuantityBox}>
                            <div className={classes.theQuantityField}>
                              <FormInput
                                value={selectedType}
                                textLabelColor="#000"
                                name="quantity"
                                border="1px solid #c5c5c5"
                                mb="0"
                                onChange={(e) =>
                                  setSelectedType(e.target.value)
                                }
                                select
                              >
                                <MenuItem value={0}>All Item</MenuItem>
                                <MenuItem value={1}>Particular Item</MenuItem>
                              </FormInput>
                            </div>
                          </div>
                          <div className={classes.theQuantityBox}>
                            <div className={classes.theQuantityField}>
                              <Button
                                onClick={() => handleCloseType()}
                                label="Confirm"
                                color="#fff"
                                bg="#1A5386"
                                size="18px"
                                pd="10px"
                                br="5px"
                                style={{ marginBottom: "10px" }}
                              />
                            </div>
                          </div>
                        </DialogContent>
                      </Dialog>
                    </React.Fragment>
                  )}
                </Section>
              }
            />
          ) : (
            <Navbar2
              children={
                <Section pd="2rem">
                  <div>
                    <div
                      onClick={() => setPage("order")}
                      style={{
                        cursor: "pointer",
                      }}
                    >
                      <Paragraph
                        color="#000"
                        bold="400"
                        size="12px"
                        margin="0 0 1rem"
                      >
                        &lt; Back
                      </Paragraph>
                    </div>
                    <div className={classes.theFlexHeader}>
                      <Paragraph color="#000" bold="600" size="24px">
                        Product List
                      </Paragraph>

                      {/* <div className={classes.theFlexBtn} style={{ marginBottom: "0" }}>
                                        <a
                                            className={classes.theCustomActionBtnFill}
                                        // onClick={() => handleOpenStockMove()}
                                        >
                                            <CheckCircleOutline sx={{ color: "#fff" }} />
                                            <Paragraph margin="0 0 0 .4rem">Approve</Paragraph>
                                        </a>
                                        <a
                                            className={classes.theCustomActionBtnFill_}
                                        // onClick={() => handleOpenStockMove()}
                                        >
                                            <DoDisturbAlt sx={{ color: "#fff" }} />
                                            <Paragraph margin="0 0 0 .4rem">Reject</Paragraph>
                                        </a>
                                    </div> */}
                    </div>
                    <div
                      style={{
                        borderBottom: "2px solid #707070",
                        padding: ".2rem 0",
                      }}
                    />
                    <br />

                    <div className={classes.theFlexAction}>
                      <div
                        style={{
                          display: "flex",
                        }}
                      >
                        <div
                          className={classes.theWx}
                          style={{ margin: "0 20px 0 0", width: "100%" }}
                        >
                          <FormInputNoLabel
                            name="search"
                            placeholder="Search"
                            border="1px solid #d7d7d7"
                            br="6px"
                            onChange={handleSearch}
                            value={searchKey}
                          />
                        </div>
                        <div
                          className={classes.theWx}
                          style={{ margin: "0 20px 0 0", width: "100%" }}
                        >
                          <FormInputNoLabel
                            name="color"
                            placeholder="Search"
                            border="1px solid #d7d7d7"
                            br="6px"
                            onChange={(e) => setColorSort(e.target.value)}
                            value={colorSort}
                            select
                          >
                            <MenuItem value="false">Select a Color</MenuItem>
                            {colorData != null &&
                              colorData.map((res) => (
                                <MenuItem
                                  value={res.colorname}
                                  style={{ color: "#000" }}
                                >
                                  {res.colorname}
                                </MenuItem>
                              ))}
                          </FormInputNoLabel>
                        </div>
                      </div>

                      <div className={classes.theFlex_}>
                        <div
                          className={
                            viewType == "grid"
                              ? classes.theIconButtonSelected
                              : classes.theIconButton
                          }
                          onClick={() => setViewType("grid")}
                        >
                          <GridView
                            sx={{
                              color: viewType == "grid" ? "#fff" : "#1A5386",
                              fontSize: "1.2rem",
                            }}
                          />
                        </div>
                        <div
                          className={
                            viewType == "list"
                              ? classes.theIconButtonSelected
                              : classes.theIconButton
                          }
                          onClick={() => setViewType("list")}
                        >
                          <List
                            sx={{
                              color: viewType == "list" ? "#fff" : "#1A5386",
                              fontSize: "1.2rem",
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={12} md={12}>
                        <Card className={classes.theCard}>
                          <TableContainer>
                            <Table>
                              <TableHead style={{ backgroundColor: "#1A5386" }}>
                                <TableRow>
                                  {/* <TableCell style={{ borderRadius: "10px 0 0 10px" }} className={classes.theHeadTitle}>
                                                                        <Checkbox
                                                                            sx={{
                                                                                color: "#fff",
                                                                                '&.Mui-checked': {
                                                                                    color: "#fff",
                                                                                },
                                                                            }} />
                                                                    </TableCell> */}
                                  {/* <TableCell className={classes.theHeadTitle}>
                                HS Code
                            </TableCell> */}
                                  <TableCell
                                    style={{ borderRadius: "10px 0 0 10px" }}
                                    className={classes.theHeadTitle}
                                  >
                                    Item Name
                                  </TableCell>
                                  <TableCell className={classes.theHeadTitle}>
                                    Size
                                  </TableCell>
                                  <TableCell className={classes.theHeadTitle}>
                                    Color
                                  </TableCell>
                                  <TableCell className={classes.theHeadTitle}>
                                    Quantity
                                  </TableCell>
                                  <TableCell className={classes.theHeadTitle}>
                                    Price
                                  </TableCell>
                                  <TableCell className={classes.theHeadTitle}>
                                    Sale Unit
                                  </TableCell>
                                  <TableCell className={classes.theHeadTitle}>
                                    Brand
                                  </TableCell>
                                  <TableCell
                                    style={{ borderRadius: "0 10px 10px 0" }}
                                    className={classes.theHeadTitle}
                                  >
                                    <MoreVert sx={{ color: "#fff" }} />
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {inventory != null &&
                                  inventory
                                    .slice(pageNum * 10, pageNum * 10 + 10)
                                    .map((item, index) => {
                                      return (
                                        <React.Fragment>
                                          <TableRow>
                                            <TableCell
                                              className={classes.theDetailRow}
                                              style={{
                                                width: "25%",
                                                background:
                                                  index % 2 == 0
                                                    ? "#E0F0F7"
                                                    : "#fff",
                                              }}
                                            >
                                              {item.itemname != "" &&
                                              item.itemname != null
                                                ? item.itemname
                                                : "-"}

                                              <div>
                                                {item.displayname != "" &&
                                                item.displayname != null
                                                  ? item.displayname
                                                  : "-"}
                                              </div>
                                            </TableCell>
                                            <TableCell
                                              className={classes.theDetailRow}
                                              style={{
                                                width: "10%",
                                                background:
                                                  index % 2 == 0
                                                    ? "#E0F0F7"
                                                    : "#fff",
                                              }}
                                            >
                                              {item.size != "" &&
                                              item.size != null
                                                ? item.size
                                                : "-"}
                                            </TableCell>
                                            <TableCell
                                              className={classes.theDetailRow}
                                              style={{
                                                width: "10%",
                                                background:
                                                  index % 2 == 0
                                                    ? "#E0F0F7"
                                                    : "#fff",
                                              }}
                                            >
                                              {item.colorname != "" &&
                                              item.colorname != null
                                                ? item.colorname
                                                : "-"}
                                            </TableCell>
                                            <TableCell
                                              className={classes.theDetailRow}
                                              style={{
                                                width: "15%",
                                                background:
                                                  index % 2 == 0
                                                    ? "#E0F0F7"
                                                    : "#fff",
                                              }}
                                            >
                                              -
                                            </TableCell>
                                            <TableCell
                                              className={classes.theDetailRow}
                                              style={{
                                                width: "10%",
                                                background:
                                                  index % 2 == 0
                                                    ? "#E0F0F7"
                                                    : "#fff",
                                              }}
                                            >
                                              {item.price != "" &&
                                              item.price != null
                                                ? item.price
                                                : "-"}
                                            </TableCell>
                                            <TableCell
                                              className={classes.theDetailRow}
                                              style={{
                                                width: "10%",
                                                background:
                                                  index % 2 == 0
                                                    ? "#E0F0F7"
                                                    : "#fff",
                                              }}
                                            >
                                              {item.saleunit != "" &&
                                              item.saleunit != null
                                                ? item.saleunit
                                                : "-"}
                                            </TableCell>

                                            <TableCell
                                              className={classes.theDetailRow}
                                              style={{
                                                width: "10%",
                                                background:
                                                  index % 2 == 0
                                                    ? "#E0F0F7"
                                                    : "#fff",
                                              }}
                                            >
                                              {item.brand != "" &&
                                              item.brand != null
                                                ? item.brand
                                                : "-"}
                                            </TableCell>
                                            {/* <TableCell
                                              className={classes.theDetailRow}
                                              style={{
                                                width: "10%",
                                                background:
                                                  index % 2 == 0
                                                    ? "#E0F0F7"
                                                    : "#fff",
                                                cursor: "pointer",
                                              }}
                    
                                              onClick={() =>
                                                item.type === "Matrix Item"
                                                  ? handleChangeTable(item)
                                                  : item.inactive == 1
                                                  ? toast(
                                                      "This item is unavailable"
                                                    )
                                                  : handleOpenAdd(item)
                                              }
                                            >
                                              {item.type === "Matrix Item" ? (
                                                item.openTable ? (
                                                  <ArrowCircleUp
                                                    sx={{ color: "#1A5386" }}
                                                  />
                                                ) : (
                                                  <ArrowCircleDown
                                                    sx={{ color: "#1A5386" }}
                                                  />
                                                )
                                              ) : (
                                                <AddCircle
                                                  sx={{ color: "red" }}
                                                />
                                              )}
                                            </TableCell> */}
                                            <TableCell
                                              className={classes.theDetailRow}
                                              style={{
                                                width: "10%",
                                                background:
                                                  index % 2 == 0
                                                    ? "#E0F0F7"
                                                    : "#fff",
                                                cursor: "pointer",
                                              }}
                                              onClick={() =>
                                                item.type === "Matrix Item" ||
                                                item.type == "Dropship Item"
                                                  ? handleChangeTable(item)
                                                  : item.inactive == 1
                                                  ? toast(
                                                      "This item is unavailable"
                                                    )
                                                  : handleOpenAdd(item)
                                              }
                                            >
                                              {item.type === "Matrix Item" ||
                                              item.type === "Dropship Item" ? (
                                                item.openTable ? (
                                                  <ArrowCircleUp
                                                    sx={{ color: "#1A5386" }}
                                                  />
                                                ) : (
                                                  <ArrowCircleDown
                                                    sx={{ color: "#1A5386" }}
                                                  />
                                                )
                                              ) : (
                                                <AddCircle
                                                  sx={{
                                                    color:
                                                      item.inactive == 1
                                                        ? "#9e9e9e"
                                                        : "#1A5386",
                                                  }}
                                                />
                                              )}
                                            </TableCell>
                                          </TableRow>
                                          {(item.type === "Matrix Item" ||
                                            item.type == "Dropship Item") && (
                                            <TableRow>
                                              <TableCell
                                                className={
                                                  classes.theDetailOpen
                                                }
                                                colSpan={8}
                                              >
                                                <Collapse
                                                  // in={item.openTable}
                                                  in={open[item.item_id]}
                                                  timeout="auto"
                                                  unmountOnExit
                                                >
                                                  {viewType == "list" ? (
                                                    <Table>
                                                      {item.children.map(
                                                        (res, resindex) => (
                                                          <TableBody>
                                                            <TableRow>
                                                              <TableCell
                                                                style={{
                                                                  width: "25%",
                                                                  background:
                                                                    index % 2 ==
                                                                    0
                                                                      ? "#E0F0F7"
                                                                      : "#fff",
                                                                  // display: "flex",
                                                                  // alignItems: "center"
                                                                }}
                                                              >
                                                                <SubdirectoryArrowRight
                                                                  sx={{
                                                                    color:
                                                                      "#1A5386",
                                                                    // marginTop: "20px"
                                                                  }}
                                                                />
                                                                {res.itemname}
                                                                <div>
                                                                  {
                                                                    res.displayname
                                                                  }
                                                                </div>
                                                              </TableCell>
                                                              <TableCell
                                                                style={{
                                                                  width: "10%",
                                                                  background:
                                                                    index % 2 ==
                                                                    0
                                                                      ? "#E0F0F7"
                                                                      : "#fff",
                                                                }}
                                                              >
                                                                {res.size}
                                                              </TableCell>
                                                              <TableCell
                                                                style={{
                                                                  width: "10%",
                                                                  background:
                                                                    index % 2 ==
                                                                    0
                                                                      ? "#E0F0F7"
                                                                      : "#fff",
                                                                }}
                                                              >
                                                                {res.colorname}
                                                              </TableCell>
                                                              <TableCell
                                                                style={{
                                                                  width: "15%",
                                                                  background:
                                                                    index % 2 ==
                                                                    0
                                                                      ? "#E0F0F7"
                                                                      : "#fff",
                                                                }}
                                                              >
                                                                On Hand:{" "}
                                                                {
                                                                  res.quantityonhand
                                                                }
                                                                <div>
                                                                  Free to use:{" "}
                                                                  {
                                                                    res.quantityavailable
                                                                  }
                                                                </div>
                                                              </TableCell>
                                                              <TableCell
                                                                style={{
                                                                  width: "10%",
                                                                  background:
                                                                    index % 2 ==
                                                                    0
                                                                      ? "#E0F0F7"
                                                                      : "#fff",
                                                                }}
                                                              >
                                                                {res.price}
                                                              </TableCell>
                                                              <TableCell
                                                                style={{
                                                                  width: "10%",
                                                                  background:
                                                                    index % 2 ==
                                                                    0
                                                                      ? "#E0F0F7"
                                                                      : "#fff",
                                                                }}
                                                              >
                                                                {res.saleunit}
                                                              </TableCell>
                                                              <TableCell
                                                                style={{
                                                                  width: "10%",
                                                                  background:
                                                                    index % 2 ==
                                                                    0
                                                                      ? "#E0F0F7"
                                                                      : "#fff",
                                                                }}
                                                              >
                                                                {res.brand !=
                                                                  "" &&
                                                                res.brand !=
                                                                  null
                                                                  ? res.brand
                                                                  : "-"}
                                                              </TableCell>
                                                              <TableCell
                                                                style={{
                                                                  width: "10%",
                                                                  background:
                                                                    index % 2 ==
                                                                    0
                                                                      ? "#E0F0F7"
                                                                      : "#fff",
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                                onClick={() =>
                                                                  handleOpenAdd(
                                                                    res
                                                                  )
                                                                }
                                                              >
                                                                <AddCircle
                                                                  sx={{
                                                                    color:
                                                                      "#1A5386",
                                                                  }}
                                                                />
                                                              </TableCell>
                                                            </TableRow>
                                                          </TableBody>
                                                        )
                                                      )}
                                                    </Table>
                                                  ) : (
                                                    <div
                                                      className={
                                                        index % 2 == 0
                                                          ? classes.theGridOdd
                                                          : classes.theGridEven
                                                      }
                                                    >
                                                      {item.children_grid.map(
                                                        (
                                                          resCGrid,
                                                          resindex
                                                        ) => (
                                                          <div
                                                            className={
                                                              classes.theGFlex
                                                            }
                                                          >
                                                            <div
                                                              className={
                                                                classes.theGFName
                                                              }
                                                            >
                                                              <Paragraph
                                                                color="#000"
                                                                bold="600"
                                                                size="0.875rem"
                                                              >
                                                                {
                                                                  resCGrid[0]
                                                                    .color
                                                                }
                                                              </Paragraph>
                                                              <Paragraph
                                                                color="#000"
                                                                bold="600"
                                                                size="0.875rem"
                                                              >
                                                                {
                                                                  resCGrid[0]
                                                                    .cataloguedescription
                                                                }
                                                              </Paragraph>
                                                            </div>
                                                            <div
                                                              className={
                                                                classes.theGFItem
                                                              }
                                                            >
                                                              {resCGrid.map(
                                                                (
                                                                  resGGM,
                                                                  resindex
                                                                ) => (
                                                                  <div
                                                                    className={
                                                                      classes.theGFIBox
                                                                    }
                                                                  >
                                                                    <Paragraph
                                                                      bold="500"
                                                                      margin="0 0 .4rem 0"
                                                                      center
                                                                    >
                                                                      {
                                                                        resGGM.size
                                                                      }
                                                                    </Paragraph>

                                                                    <FormInput
                                                                      border="1px solid #d7d7d7"
                                                                      name="quantity"
                                                                      // onKeyDown={(e) => e.key === 'Enter' && handleChangeGrid(e, index)}
                                                                      onBlur={(
                                                                        e
                                                                      ) =>
                                                                        handleChangeGrid(
                                                                          e,
                                                                          index
                                                                        )
                                                                      }
                                                                      className="customTextField"
                                                                      id={
                                                                        resGGM.internalid +
                                                                        "_" +
                                                                        resGGM.hscode +
                                                                        "_" +
                                                                        resGGM.itemname +
                                                                        "_" +
                                                                        resGGM.price +
                                                                        "_" +
                                                                        resGGM.type +
                                                                        "_" +
                                                                        resGGM.color +
                                                                        "_" +
                                                                        resGGM.quantityavailable +
                                                                        "_" +
                                                                        resGGM.size
                                                                      }
                                                                      // onKeyPress={(event) => {
                                                                      //     if (!/[0-9]/.test(event.key)) {
                                                                      //         event.preventDefault();
                                                                      //     }
                                                                      // }}
                                                                      center
                                                                      type="number"
                                                                      inputProps={{
                                                                        min: 1,
                                                                        max:
                                                                          item.type ==
                                                                          "Matrix Item"
                                                                            ? resGGM.quantityavailable
                                                                            : 9999999,
                                                                      }}
                                                                      bg={
                                                                        item.type !=
                                                                          "Dropship Item" &&
                                                                        (resGGM.price ==
                                                                          0 ||
                                                                          resGGM.inactive ==
                                                                            1 ||
                                                                          resGGM.quantityavailable <=
                                                                            0)
                                                                          ? "#d7d7d7"
                                                                          : "#fff"
                                                                      }
                                                                      disabled={
                                                                        item.type !=
                                                                          "Dropship Item" &&
                                                                        (resGGM.price ==
                                                                          0 ||
                                                                          resGGM.inactive ==
                                                                            1 ||
                                                                          resGGM.quantityavailable <=
                                                                            0)
                                                                          ? true
                                                                          : false
                                                                      }
                                                                      // bg={resGGM.quantityavailable == 0 || resGGM.price == 0 ? "#d7d7d7" : "#fff"}
                                                                      // disabled={resGGM.quantityavailable == 0 || resGGM.price == 0 ? true : false}
                                                                    />

                                                                    <Paragraph
                                                                      style={{
                                                                        fontStyle:
                                                                          "italic",
                                                                      }}
                                                                      margin="0"
                                                                      bold="600"
                                                                      center
                                                                    >
                                                                      {
                                                                        orderData.currency
                                                                      }{" "}
                                                                      {parseFloat(
                                                                        resGGM.price
                                                                      ).toFixed(
                                                                        2
                                                                      )}
                                                                    </Paragraph>
                                                                    <Paragraph
                                                                      style={{
                                                                        fontStyle:
                                                                          "italic",
                                                                      }}
                                                                      margin="0"
                                                                      center
                                                                      color="#C52626"
                                                                    >
                                                                      On Hand:{" "}
                                                                      {
                                                                        resGGM.quantityonhand
                                                                      }
                                                                    </Paragraph>
                                                                    <Paragraph
                                                                      style={{
                                                                        fontStyle:
                                                                          "italic",
                                                                      }}
                                                                      margin="0"
                                                                      center
                                                                      color="#C52626"
                                                                    >
                                                                      Free to
                                                                      use:{" "}
                                                                      {
                                                                        resGGM.quantityavailable
                                                                      }
                                                                    </Paragraph>
                                                                    <div
                                                                      onClick={() =>
                                                                        handleOpenAddDesc(
                                                                          resGGM
                                                                        )
                                                                      }
                                                                    >
                                                                      <Paragraph
                                                                        textDecoration="underline"
                                                                        margin="0"
                                                                        center
                                                                        color="#1A5386"
                                                                      >
                                                                        + Add
                                                                        Description
                                                                      </Paragraph>
                                                                    </div>
                                                                    <input
                                                                      value={
                                                                        resGGM.internalid
                                                                      }
                                                                      name="id"
                                                                      onChange={(
                                                                        e
                                                                      ) =>
                                                                        handleChangeGrid(
                                                                          e,
                                                                          index
                                                                        )
                                                                      }
                                                                      type="hidden"
                                                                    />
                                                                  </div>
                                                                )
                                                              )}
                                                            </div>
                                                          </div>
                                                        )
                                                      )}

                                                      {/* <div className={classes.theAddtoCartBtn}>
                                                                      <Button
                                                                          label="ADD TO CART"
                                                                          color="#FFF"
                                                                          bg="#565656"
                                                                          br="4px"
                                                                          pd=".4rem 1.2rem"
                                                                          size="14px"
                                                                          onClick={() => handleAddMultipleProduct()}
                                                                      />
                                                                  </div> */}
                                                    </div>
                                                  )}
                                                </Collapse>
                                              </TableCell>
                                            </TableRow>
                                          )}
                                        </React.Fragment>
                                      );
                                    })}
                              </TableBody>
                            </Table>
                          </TableContainer>

                          <div
                            style={{
                              borderTop: "1px solid #707070",
                              borderBottom: "1px solid #707070",
                              margin: "1rem 0 0",
                              cursor: "pointer",
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "flex-end",
                            }}
                          >
                            <TablePagination
                              // variant="outlined"
                              color="primary"
                              page={pageNum}
                              onPageChange={handleChangePage}
                              count={totalList}
                              // defaultPage={pageList}
                              rowsPerPage={10}
                              rowsPerPageOptions={[10]}
                              // count={10}
                            />
                          </div>
                        </Card>
                        <br />
                        <br />
                      </Grid>
                    </Grid>
                    <br />
                  </div>

                  {selectedItem != null && (
                    <Dialog
                      onClose={handleCloseAdd}
                      open={openAdd}
                      fullWidth="true"
                      maxWidth="sm"
                    >
                      <DialogTitle>
                        <Paragraph
                          color="#1A5386"
                          bold="600"
                          size="24px"
                          center
                        >
                          Enter Detail
                        </Paragraph>
                      </DialogTitle>
                      <DialogContent>
                        <div className={classes.theQuantityBox}>
                          <RemoveCircle
                            sx={{ fontSize: "2rem", color: "#1A5386" }}
                            onClick={() =>
                              selectedItem.quantity > 1 &&
                              setSelectedItem({
                                ...selectedItem,
                                quantity: parseInt(selectedItem.quantity) - 1,
                              })
                            }
                          />
                          <div className={classes.theQuantityField}>
                            <FormInput
                              value={
                                selectedItem !== null &&
                                parseInt(selectedItem.quantity)
                              }
                              textLabelColor="#000"
                              name="quantity"
                              onKeyPress={(event) => {
                                if (
                                  event.target.value === "" &&
                                  !/-?[0-9]/.test(event.key)
                                ) {
                                  event.preventDefault();
                                }
                              }}
                              // type='number'
                              inputProps={{
                                min: 1,
                                max: selectedItem.quantityavailable,
                              }}
                              border="1px solid #c5c5c5"
                              mb="0"
                              center
                              onChange={handleChangeProduct2}
                            />
                          </div>
                          <AddCircle
                            onClick={() =>
                              setSelectedItem({
                                ...selectedItem,
                                quantity: parseInt(selectedItem.quantity) + 1,
                              })
                            }
                            sx={{ fontSize: "2rem", color: "#1A5386" }}
                          />
                        </div>
                        <div className={classes.theQuantityBox}>
                          <div className={classes.theQuantityField}>
                            <FormInput
                              value={
                                selectedItem !== null && selectedItem.price
                              }
                              textLabelColor="#000"
                              disabled={
                                selectedItem != null &&
                                selectedItem.type != "Matrix Item"
                                  ? false
                                  : true
                              }
                              name="price"
                              placeholder="Price"
                              border="1px solid #c5c5c5"
                              mb="0"
                              type="number"
                              inputProps={{ min: 0 }}
                              onChange={handleChangeProduct}
                            />
                          </div>
                        </div>
                        <div className={classes.theQuantityBox}>
                          <div className={classes.theQuantityField}>
                            <FormInput
                              value={
                                selectedItem !== null &&
                                selectedItem.description
                              }
                              textLabelColor="#000"
                              name="description"
                              placeholder="Description"
                              border="1px solid #c5c5c5"
                              mb="0"
                              multiline
                              minRows={4}
                              onChange={handleChangeProduct}
                            />
                          </div>
                        </div>
                        <div className={classes.theQuantityBox}>
                          <div className={classes.theQuantityField}>
                            <Button
                              onClick={() =>
                                (selectedItem.type == "Matrix Item" ||
                                  selectedItem.type == "Dropship Item") &&
                                selectedItem.price == 0
                                  ? toast("Invalid Price")
                                  : handleAddProduct()
                              }
                              label="Confirm"
                              color="#fff"
                              bg={
                                (selectedItem.type == "Matrix Item" ||
                                  selectedItem.type == "Dropship Item") &&
                                selectedItem.price == 0
                                  ? "#c5c5c5"
                                  : "#1A5386"
                              }
                              size="18px"
                              pd="10px"
                              br="5px"
                              style={{ marginBottom: "10px" }}
                            />
                          </div>
                        </div>
                      </DialogContent>
                    </Dialog>
                  )}

                  {selectedGrid != null && (
                    <Dialog
                      onClose={handleCloseAddDesc}
                      open={openAddDesc}
                      fullWidth="true"
                      maxWidth="sm"
                    >
                      <DialogTitle>
                        <Paragraph color="#1A5386" bold="600" size="24px">
                          Add Description
                        </Paragraph>
                      </DialogTitle>
                      <DialogContent>
                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={12} md={12}>
                            <FormInput
                              value={
                                selectedGrid !== null &&
                                selectedGrid.description
                              }
                              textLabelColor="#000"
                              name="description"
                              placeholder="Description"
                              border="1px solid #c5c5c5"
                              mb="1rem"
                              multiline
                              minRows={4}
                              onChange={handleChangeDesc}
                            />
                          </Grid>
                        </Grid>
                        <Button
                          onClick={() => handleAddDEsc()}
                          label="Add"
                          color="#fff"
                          bg="#1A5386"
                          size="18px"
                          pd="10px"
                          br="5px"
                          style={{ marginBottom: "10px" }}
                        />
                      </DialogContent>
                    </Dialog>
                  )}
                  <div
                    className={classes.theFloatCartBig}
                    style={{
                      display: displayFloat ? "block" : "none",
                    }}
                  >
                    <div className={classes.theFCHeader}>
                      <Paragraph color="#fff" bold="600" size="14px">
                        Added Product List
                      </Paragraph>
                    </div>
                    <div className={classes.theFCTable}>
                      <TableContainer style={{ maxHeight: 300 }}>
                        <Table>
                          <TableHead style={{ backgroundColor: "#fff" }}>
                            <TableRow>
                              <TableCell className={classes.theCartTitle}>
                                Item Name
                              </TableCell>
                              <TableCell className={classes.theCartTitle}>
                                Description
                              </TableCell>
                              <TableCell className={classes.theCartTitle}>
                                Attributes
                              </TableCell>
                              <TableCell
                                style={{ textAlign: "center" }}
                                className={classes.theCartTitle}
                              >
                                Discount Amount
                              </TableCell>
                              <TableCell
                                style={{ textAlign: "center" }}
                                className={classes.theCartTitle}
                              >
                                Pricing
                              </TableCell>
                              <TableCell
                                className={classes.theCartTitle}
                              ></TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {productList.length > 0 &&
                              productList.map((productRest, index) => (
                                <TableRow>
                                  <TableCell
                                    style={{
                                      width: "15%",
                                    }}
                                  >
                                    {productRest.itemname != "" &&
                                    productRest.itemname != null
                                      ? productRest.itemname
                                      : "-"}
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      width: "20%",
                                    }}
                                  >
                                    <pre
                                      style={{
                                        margin: 0,
                                        fontFamily: "Roboto,Helvetica, Arial",
                                      }}
                                    >
                                      {productRest.description != "" &&
                                      productRest.description != null
                                        ? productRest.description
                                        : "-"}
                                    </pre>
                                    <div
                                      onClick={() =>
                                        handleOpenAddIndexProduct(productRest)
                                      }
                                    >
                                      <Paragraph
                                        textDecoration="underline"
                                        margin="0"
                                        color="#1A5386"
                                      >
                                        Edit Description
                                      </Paragraph>
                                    </div>
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      width: "15%",
                                      wordBreak: "break-all",
                                    }}
                                  >
                                    Clr:{" "}
                                    {productRest.color != "" &&
                                    productRest.color != null
                                      ? productRest.color
                                      : "-"}
                                    <div>
                                      Sz:{" "}
                                      {productRest.size != "" &&
                                      productRest.size != null
                                        ? productRest.size
                                        : "-"}
                                    </div>
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      width: "25%",
                                      textAlign: "center",
                                    }}
                                  >
                                    {" "}
                                    {productRest.given_discount != "" &&
                                    productRest.given_discount != null
                                      ? productRest.given_discount
                                      : ""}
                                    <div
                                      onClick={() =>
                                        handleOpenAddIndexProductDiscount(
                                          productRest
                                        )
                                      }
                                    >
                                      <Paragraph
                                        textDecoration="underline"
                                        margin="0"
                                        color="#1A5386"
                                        center
                                      >
                                        Edit Discount Amount
                                      </Paragraph>
                                    </div>
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    style={{
                                      width: "20%",
                                    }}
                                  >
                                    SP -{" "}
                                    {parseFloat(productRest.price).toFixed(2)}
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        margin: "4px 0",
                                      }}
                                    >
                                      <RemoveCircle
                                        sx={{
                                          color: "#1A5386",
                                          marginRight: "10px",
                                        }}
                                        onClick={() =>
                                          handleChangeQty(index, -1)
                                        }
                                      />
                                      {productRest.quantity}
                                      <AddCircle
                                        onClick={() =>
                                          handleChangeQty(index, 1)
                                        }
                                        sx={{
                                          color: "#1A5386",
                                          marginLeft: "10px",
                                        }}
                                      />
                                    </div>
                                    TP -{" "}
                                    {(
                                      parseFloat(productRest.price) *
                                      parseFloat(productRest.quantity)
                                    ).toFixed(2)}
                                  </TableCell>
                                  <TableCell>
                                    <Close
                                      sx={{ color: "#C52626" }}
                                      onClick={() => handleRemoveItem(index)}
                                    />
                                  </TableCell>
                                </TableRow>
                              ))}

                            {/* {productList.length > 0 &&
                              productList.map((productRest, index) => (
                                <TableRow>
                                  <TableCell
                                    style={{
                                      width: "80%",
                                   
                                    }}
                                  >
                                    {productRest.itemname != "" &&
                                    productRest.itemname != null
                                      ? productRest.itemname
                                      : "-"}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    style={{
                                      width: "20%",
                                    
                                    }}
                                  >
                                    {productRest.quantity}
                                  
                                  </TableCell>
                                </TableRow>
                              ))} */}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                    <div className={classes.theFCFooter}>
                      <div
                        className={classes.theCheckoutBtn}
                        style={{ margin: "0 10px 0 0" }}
                      >
                        <Button
                          label="Back"
                          color="#FFF"
                          bg="#1A5386"
                          br="4px"
                          pd=".4rem 1.2rem"
                          size="14px"
                          onClick={() => {
                            setPage("order");
                            setTimeout(() => {
                              OrderProductRef.current.scrollIntoView({
                                behavior: "smooth",
                              });
                            }, 300);
                            // setPage('order');
                            // OrderProductRef.current.scrollIntoView({ behavior: "smooth" })
                          }}
                        />
                      </div>
                      <div className={classes.theCheckoutBtn}>
                        <Button
                          label="Checkout"
                          color="#FFF"
                          bg="#1A5386"
                          br="4px"
                          pd=".4rem 1.2rem"
                          size="14px"
                          onClick={() => {
                            handleSubmitAdd();
                            // setPage('order');
                            // OrderProductRef.current.scrollIntoView({ behavior: "smooth" })
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div
                    className={classes.theShirtIcon}
                    onClick={() => setDisplayFloat(!displayFloat)}
                  >
                    <div className={classes.theSIImage}>
                      <img src={ShirtIcon} />
                    </div>
                    <div
                      style={{
                        backgroundColor: "#C52626",
                        width: "25px",
                        height: "25px",
                        position: "absolute",
                        top: "-6px",
                        right: "-6px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "50%",
                      }}
                    >
                      <Paragraph color="#fff" bold="600" size="12px">
                        {productList.length}
                      </Paragraph>
                    </div>
                  </div>

                  {selectedIndexProduct != null && (
                    <Dialog
                      onClose={handleCloseIndexProduct}
                      open={openEditDesc}
                      fullWidth="true"
                      maxWidth="sm"
                    >
                      <DialogTitle>
                        <Paragraph color="#1A5386" bold="600" size="24px">
                          Edit Description
                        </Paragraph>
                      </DialogTitle>
                      <DialogContent>
                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={12} md={12}>
                            <FormInput
                              value={
                                selectedIndexProduct !== null &&
                                selectedIndexProduct.description
                              }
                              textLabelColor="#000"
                              name="description"
                              placeholder="Description"
                              border="1px solid #c5c5c5"
                              mb="1rem"
                              multiline
                              minRows={4}
                              onChange={handleChangeIndexProduct}
                            />
                          </Grid>
                        </Grid>
                        <Button
                          onClick={() => handleCloseIndexProduct()}
                          label="Save"
                          color="#fff"
                          bg="#1A5386"
                          size="18px"
                          pd="10px"
                          br="5px"
                          style={{ marginBottom: "10px" }}
                        />
                      </DialogContent>
                    </Dialog>
                  )}

                  {selectedIndexProduct != null && (
                    <Dialog
                      onClose={handleOpenAddIndexProductDiscount}
                      open={openEditDis}
                      fullWidth="true"
                      maxWidth="sm"
                    >
                      <DialogTitle>
                        <Paragraph color="#1A5386" bold="600" size="24px">
                          Edit Discount Amount
                        </Paragraph>
                      </DialogTitle>
                      <DialogContent>
                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={12} md={12}>
                            <FormInput
                              value={
                                selectedIndexProduct !== null &&
                                selectedIndexProduct.given_discount
                              }
                              type="number"
                              textLabelColor="#000"
                              name="given_discount"
                              placeholder="Discount Amount"
                              border="1px solid #c5c5c5"
                              mb="1rem"
                              onChange={handleChangeIndexProduct}
                            />
                          </Grid>
                        </Grid>
                        <Button
                          onClick={() => handleCloseIndexProductDiscount()}
                          label="Save"
                          color="#fff"
                          bg="#1A5386"
                          size="18px"
                          pd="10px"
                          br="5px"
                          style={{ marginBottom: "10px" }}
                        />
                      </DialogContent>
                    </Dialog>
                  )}
                </Section>
              }
            />
          )}
        </React.Fragment>
      )}
      <Dialog
        onClose={handleCloseShippingMethod}
        open={openEditShippingMethod}
        fullWidth="true"
        maxWidth="sm"
      >
        <DialogTitle>
          <Paragraph color="#1A5386" bold="600" size="24px">
            Edit Shipping Method
          </Paragraph>
        </DialogTitle>
        <DialogContent>
          <Paragraph margin="0 0 .4rem 0">Customer Address*</Paragraph>
          <FormInputSelect>
            <Select
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
              // name="name"
              value={selectedCustomerAddress}
              onChange={handleChooseCustomerAddress}
              style={{ marginBottom: "1rem" }}
            >
              <MenuItem value="" style={{ fontWeight: "400" }}>
                <em style={{ color: "#878787" }}>
                  Please Choose a Shipping Address
                </em>
              </MenuItem>
              {customerAddrsssList.map((item) => (
                <MenuItem
                  value={item.customer_address_id}
                  style={{ color: "#000" }}
                >
                  {item.addr1}, {item.add2},{item.city},{item.zip},{item.state},
                  {item.country}
                </MenuItem>
              ))}
            </Select>
          </FormInputSelect>

          <Paragraph margin="0 0 .4rem 0">Shipping Method*</Paragraph>
          <FormInputSelect>
            <Select
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
              value={selectedShippingMethod}
              onChange={handleChangeShippingMethod}
              // style={{ marginBottom: "0" }}
            >
              <MenuItem value="" style={{ fontWeight: "400" }}>
                <em style={{ color: "#878787" }}>
                  Please Choose a Shipping Method
                </em>
              </MenuItem>
              {shippingMethod.map((item) => (
                <MenuItem
                  value={item.shipping_method_id}
                  style={{ color: "#000" }}
                >
                  {item.shippingmethod}
                </MenuItem>
              ))}
            </Select>
          </FormInputSelect>

          <Paragraph margin="0 0 .4rem 0">Shipping Carrier*</Paragraph>
          <FormInputSelect
            disabled={shippingCarrier.length == 0 ? true : false}
            bg={shippingCarrier.length == 0 ? "#C5C5C5" : "#FFF"}
          >
            <Select
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
              value={selectedShippingCarrier}
              onChange={handleChangeShippingCarrier}
              // style={{ marginBottom: "0" }}
            >
              <MenuItem value="" style={{ fontWeight: "400" }}>
                <em style={{ color: "#878787" }}>
                  Please Choose a Shipping Carrier
                </em>
              </MenuItem>
              {shippingCarrier.map((item) => (
                <MenuItem
                  value={item.shipping_carrier_id}
                  style={{ color: "#000" }}
                >
                  {item.shippingcarrier}
                </MenuItem>
              ))}
            </Select>
          </FormInputSelect>
          <br />
          <br />
          <Button
            onClick={() => handleSubmitEditShippingMethod()}
            label="Save"
            color="#fff"
            bg="#1A5386"
            size="18px"
            pd="10px"
            br="5px"
            style={{ marginBottom: "10px" }}
          />
        </DialogContent>
      </Dialog>

      <Dialog
        onClose={() => setOpenInput(false)}
        open={openInput}
        fullWidth="true"
        maxWidth="sm"
      >
        <DialogContent>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={12}>
              <FormInput
                value={razerID}
                label="Razer ID"
                textLabelColor="#000"
                name="razerid"
                placeholder="RazerID"
                border="1px solid #c5c5c5"
                mb="1rem"
                onChange={handleChangeRazerID}
              />
              <FormInput
                value={tranDate}
                label="Date"
                textLabelColor="#000"
                name="razerid"
                placeholder="Date"
                border="1px solid #c5c5c5"
                mb="1rem"
                type="date"
                onChange={handleChangeTranDate}
              />
            </Grid>
          </Grid>
          <Button
            onClick={() => handleResync()}
            label="Submit"
            color="#fff"
            bg="#1A5386"
            size="18px"
            pd="10px"
            br="5px"
            style={{ marginBottom: "10px" }}
          />
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}


